// Tamil (தமிழ்) translations. Keep keys in sync with en.ts.
// These translations are an initial pass — please have a native Tamil
// speaker review before relying on them in production.
import type { Dict } from './en';

export const ta: Dict = {
  common: {
    saving: 'சேமிக்கிறது…',
    deleting: 'நீக்குகிறது…',
    appName: 'Synapse',
    appNameLong: 'Synapse மருத்துவ சரக்கு',
    version: 'v0.0.1',
    cancel: 'ரத்து செய்',
    confirm: 'உறுதிப்படுத்து',
    save: 'சேமி',
    submit: 'சமர்ப்பி',
    submitting: 'சமர்ப்பிக்கப்படுகிறது…',
    delete: 'நீக்கு',
    edit: 'திருத்து',
    remove: 'அகற்று',
    add: 'சேர்',
    close: 'மூடு',
    back: 'பின்',
    backToHome: 'முகப்புக்கு திரும்பு',
    next: 'அடுத்து',
    previous: 'முந்தைய',
    loading: 'ஏற்றப்படுகிறது…',
    searching: 'தேடப்படுகிறது…',
    lookingUp: 'தேடப்படுகிறது…',
    tryAgain: 'மீண்டும் முயற்சிக்கவும்',
    retry: 'மீண்டும் முயற்சி',
    optional: 'விருப்பத்தேர்வு',
    required: 'தேவை',
    yes: 'ஆம்',
    no: 'இல்லை',
    or: 'அல்லது',
    pick: 'தேர்வு',
    none: 'எதுவுமில்லை',
    all: 'அனைத்தும்',
    signOut: 'வெளியேறு',
    admin: 'நிர்வாகி',
    staff: 'பணியாளர்',
    draft: 'வரைவு',
    pending: 'நிலுவையில்',
    actions: 'செயல்கள்',
    learnMore: 'மேலும் அறிய',
    justNow: 'இப்போது தான்',
    minutesAgo: '{{count}} நிமிடங்களுக்கு முன்',
    hoursAgo: '{{count}} மணி நேரத்திற்கு முன்',
    daysAgo: '{{count}} நாட்களுக்கு முன்',
    unit_one: 'அலகு',
    unit_other: 'அலகுகள்',
    item_one: 'பொருள்',
    item_other: 'பொருட்கள்',
    line_one: 'வரி',
    line_other: 'வரிகள்',
    batch_one: 'தொகுதி',
    batch_other: 'தொகுதிகள்',
    onHand: 'கையிருப்பு',
    expired: 'காலாவதியானது',
    expiringSoon: 'விரைவில் காலாவதியாகும்',
    outOfStock: 'கையிருப்பில் இல்லை',
    inStockN: 'கையிருப்பில் {{count}}',
    brandName: 'பிராண்ட் பெயர்',
    genericName: 'பொதுவான பெயர்',
    strength: 'வலிமை',
    quantity: 'அளவு',
    unit: 'அலகு',
    batch: 'தொகுதி',
    batchNumber: 'தொகுதி எண்',
    barcode: 'பார்கோடு',
    expiry: 'காலாவதி',
    manufacturer: 'உற்பத்தியாளர்',
    storageCondition: 'சேமிப்பு நிலை',
    notes: 'குறிப்புகள்',
    note: 'குறிப்பு',
    reason: 'காரணம்',
    email: 'மின்னஞ்சல்',
    workEmail: 'பணி மின்னஞ்சல்',
    password: 'கடவுச்சொல்',
    firstName: 'முதல் பெயர்',
    lastName: 'கடைசி பெயர்',
    name: 'பெயர்',
    role: 'பங்கு',
    decreaseQuantity: 'அளவைக் குறை',
    increaseQuantity: 'அளவை அதிகரி',
    unknown: 'தெரியாத',
    language: 'மொழி',
    changeLanguage: 'மொழியை மாற்று',
    refreshPage: 'பக்கத்தைப் புதுப்பி',
  },

  unit: {
    tablets: 'மாத்திரைகள்',
    capsules: 'காப்சூல்கள்',
    bottles: 'பாட்டில்கள்',
    vials: 'குப்பிகள்',
    ml: 'மி.லி.',
    sachets: 'பாக்கெட்டுகள்',
    ampoules: 'ஆம்பியூல்கள்',
    drops: 'துளிகள்',
    pieces: 'துண்டுகள்',
    boxes: 'பெட்டிகள்',
    pairs: 'ஜோடிகள்',
    rolls: 'ரோல்கள்',
    packs: 'பாக்கெட்டுகள்',
    units: 'அலகுகள்',
    tests: 'சோதனைகள்',
    strips: 'கீற்றுகள்',
  },

  scan: {
    title: 'பார்கோடு ஸ்கேன் செய்',
    description: 'கேமராவை பார்கோடிற்கு நேராக காட்டுங்கள். நாங்கள் அதை தானாக தேடுவோம்.',
    use: 'பயன்படுத்து',
    captured: 'பிடிக்கப்பட்டது',
    typeInstead: 'அதற்கு பதிலாக தட்டச்சு செய்',
    useCameraInstead: 'அதற்கு பதிலாக கேமராவைப் பயன்படுத்து',
    rescan: 'மீண்டும் ஸ்கேன் செய்',
    typePrompt: 'பார்கோடை தட்டச்சு செய்யவும் அல்லது ஒட்டவும், நாங்கள் அதைத் தேடுவோம்.',
    barcodePlaceholder: '0 0000 00000 0',
    err: {
      permissionDenied: 'கேமரா அணுகல் மறுக்கப்பட்டது. பார்கோடை கைமுறையாக உள்ளிடவும்.',
      noCamera: 'இந்த சாதனத்தில் கேமரா இல்லை. பார்கோடை கைமுறையாக உள்ளிடவும்.',
      insecureContext: 'கேமராவிற்கு பாதுகாப்பான (HTTPS) பக்கம் தேவை. பார்கோடை கைமுறையாக உள்ளிடவும்.',
      unsupported: 'இந்த உலாவியால் கேமராவை அணுக முடியாது. பார்கோடை கைமுறையாக உள்ளிடவும்.',
      security: 'பாதுகாப்பு கொள்கையால் கேமரா தடுக்கப்பட்டுள்ளது. பார்கோடை கைமுறையாக உள்ளிடவும்.',
      inUse: 'கேமரா மற்றொரு பயன்பாட்டில் உள்ளது. அதை மூடவும் அல்லது "அதற்கு பதிலாக தட்டச்சு செய்" பயன்படுத்தவும்.',
      overconstrained: 'கோரப்பட்ட அமைப்புகளுக்கு எந்த கேமராவும் பொருந்தவில்லை. "அதற்கு பதிலாக தட்டச்சு செய்" முயற்சிக்கவும்.',
    },
  },

  greeting: {
    night: 'இனிய இரவு',
    morning: 'காலை வணக்கம்',
    afternoon: 'மதிய வணக்கம்',
    evening: 'மாலை வணக்கம்',
  },

  itemType: {
    medication: 'மருந்து',
    consumable: 'நுகர்பொருள்',
    medical_device: 'மருத்துவ சாதனம்',
    reagent: 'வினையாக்கி',
    other: 'மற்றவை',
  },

  // Shared clinical field-type components (Stage 4 library).
  fields: {
    other: 'மற்றவை',
    add: 'சேர்',
    addNotes: 'குறிப்புகளைச் சேர்…',
    typeToSearchOrAdd: 'தேட அல்லது சேர்க்க தட்டச்சு செய்க…',
    searchMedicineDb: 'மருந்து தரவுத்தளத்தில் தேடு…',
    freeText: 'தனி உரை',
    statusEmpty: 'காலி',
    statusFilled: 'முடிந்தது',
    statusFinding: 'கண்டுபிடிப்பு',
  },

  // Phase 1 patient screens (Stage 5). Initial pass — review with a native speaker.
  patients: {
    title: 'நோயாளிகள்',
    subtitle: 'பெயர், தொலைபேசி அல்லது தேசிய அடையாள எண் மூலம் கிளினிக் நோயாளி பதிவுகளைத் தேடுங்கள்.',
    searchPlaceholder: 'பெயர், தொலைபேசி அல்லது அடையாளம் மூலம் தேடு',
    searchLabel: 'நோயாளிகளைத் தேடு',
    clearSearch: 'தேடலை அழி',
    recentPatients: 'சமீபத்திய நோயாளிகள்',
    searchingLabel: 'தேடுகிறது…',
    resultsCount_one: '“{{query}}” உடன் பொருந்தும் {{count}} நோயாளி',
    resultsCount_other: '“{{query}}” உடன் பொருந்தும் {{count}} நோயாளிகள்',
    resultsHeader_one: '{{count}} முடிவு · “{{query}}”',
    resultsHeader_other: '{{count}} முடிவுகள் · “{{query}}”',
    noResultsTitle: 'நோயாளி எவரும் கிடைக்கவில்லை',
    noResultsBody: '“{{query}}” உடன் எதுவும் பொருந்தவில்லை. எழுத்துப்பிழையைச் சரிபார்க்கவும், அல்லது புதிய நோயாளியாகச் சேர்க்கவும்.',
    addAsNew: '“{{query}}” ஐ புதிய நோயாளியாகச் சேர்',
    newPatient: 'புதிய நோயாளி',
    yrs: 'வயது',
    mrnLabel: 'MRN',
    nicLabel: 'NIC',
    noRecentTitle: 'இன்னும் நோயாளிகள் இல்லை',
    noRecentBody: 'நீங்கள் உருவாக்கும் அல்லது திறக்கும் நோயாளிகள் விரைவு அணுகலுக்காக இங்கே தோன்றும்.',
    couldNotLoad: 'நோயாளிகளை ஏற்ற முடியவில்லை',
    couldNotLoadMsg: 'நோயாளிகளை ஏற்றுவதில் ஏதோ தவறு நடந்துள்ளது. மீண்டும் முயற்சிக்கவும்.',
    selectPatientTitle: 'ஒரு நோயாளியைத் தேர்ந்தெடு',
    selectPatientBody: 'பட்டியலில் இருந்து ஒருவரைத் தேர்ந்தெடுத்து அவர்களின் விளக்கப்படத்தைத் திறந்து, வரலாற்றைப் பார்த்து, ஆலோசனையைத் தொடங்கவும்.',
    kbdSearch: 'தேடு',
    kbdNavigate: 'வழிசெலுத்து',
    kbdMove: 'நகர்த்து',
    kbdOpen: 'திற',
    backToPatients: 'நோயாளிகளுக்குத் திரும்பு',
    quickCreate: {
      title: 'புதிய நோயாளி',
      subtitle: 'அத்தியாவசியங்களுடன் ஒரு பதிவை உருவாக்குங்கள் — மீதி ஆலோசனையில் பதிவாகும்.',
      fullName: 'முழுப் பெயர்',
      fullNameHint: 'உங்கள் தேடலில் இருந்து கொண்டுவரப்பட்டது.',
      fullNameRequired: 'நோயாளியின் பெயரை உள்ளிடவும்.',
      sex: 'பாலினம்',
      sexHint: 'பின்னர் மகப்பேறு படிநிலை தோன்றுமா என்பதை தீர்மானிக்கிறது.',
      dateOfBirth: 'பிறந்த தேதி',
      age: 'வயது',
      ageHint: 'சரியான பிறந்த தேதி தெரியாவிட்டால் பயன்படுத்தவும்.',
      ageUnit: 'வயது',
      ageApproxHint: 'தோராயமான பிறந்த தேதியாக சேமிக்கப்படுகிறது (ஜனவரி 1).',
      phone: 'தொலைபேசி',
      nationalId: 'தேசிய அடையாளம் (NIC)',
      nationalIdPlaceholder: 'எ.கா. 199512300456',
      nationalIdHint: '9 இலக்கங்கள் பின் V, அல்லது 12 இலக்கங்கள்',
      nationalIdInvalid:
        'இது தேசிய அடையாள எண் போல் இல்லை. 9 இலக்கங்களுக்குப் பிறகு V அல்லது X (எ.கா. 953120456V), அல்லது 12 இலக்க எண்ணை உள்ளிடவும்.',
      phoneInvalid: 'குறைந்தது 7 இலக்கங்கள் கொண்ட தொலைபேசி எண்ணை உள்ளிடவும்.',
      infoNote: 'முகவரி, தொழில் மற்றும் மீதி ஆலோசனையில் உறுதிப்படுத்தப்படும் — இது நோயாளியை உருவாக்குவதை வேகமாக்குகிறது.',
      create: 'உருவாக்கி நோயாளியைத் திற',
      creating: 'உருவாக்குகிறது…',
      createFailed: 'நோயாளியை உருவாக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.',
      createdButExtrasFailed:
        'நோயாளி உருவாக்கப்பட்டார் — பிறந்த தேதி / NIC ஐ சேமிக்க முடியவில்லை. அவற்றைச் சேர்க்க பதிவைத் திருத்தவும்.',
      photo: 'புகைப்படம்',
      createdButPhotoFailed:
        'நோயாளி உருவாக்கப்பட்டார் — புகைப்படத்தைப் பதிவேற்ற முடியவில்லை. அதைச் சேர்க்க பதிவைத் திறக்கவும்.',
    },
    photo: {
      takePhoto: 'புகைப்படம் எடு',
      capture: 'எடு',
      switchCamera: 'கேமராவை மாற்று',
      choose: 'கோப்பைத் தேர்ந்தெடு',
      remove: 'அகற்று',
      edit: 'புகைப்படத்தைத் திருத்து',
      view: 'புகைப்படத்தைப் பார்',
      hint: 'கேமராவைப் பயன்படுத்தவும், அல்லது gallery / கோப்புகளில் இருந்து தேர்ந்தெடுக்கவும்.',
      readFailed: 'அந்தப் படத்தைப் படிக்க முடியவில்லை. வேறு கோப்பை முயற்சிக்கவும்.',
      captureFailed: 'புகைப்படத்தை எடுக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.',
      cameraDenied: 'கேமரா அணுகல் தடுக்கப்பட்டது. அதை அனுமதிக்கவும், அல்லது கோப்பைத் தேர்ந்தெடுக்கவும்.',
      cameraUnavailable: 'கேமரா எதுவும் இல்லை. பதிலாக ஒரு கோப்பைத் தேர்ந்தெடுக்கவும்.',
      cameraUnsupported: 'இந்தச் சாதனம் அல்லது உலாவியால் கேமராவைப் பயன்படுத்த முடியாது. கோப்பைத் தேர்ந்தெடுக்கவும்.',
      uploadFailed: 'புகைப்படத்தைப் பதிவேற்ற முடியவில்லை. மீண்டும் முயற்சிக்கவும்.',
      removeFailed: 'புகைப்படத்தை அகற்ற முடியவில்லை. மீண்டும் முயற்சிக்கவும்.',
    },
    sexMale: 'ஆண்',
    sexFemale: 'பெண்',
    sexOther: 'மற்றவை',
    sexUnknown: 'தெரியவில்லை',
    editDialog: {
      subtitle: 'இந்த நோயாளியைப் பதிவு செய்தபோது சேகரிக்கப்பட்ட விவரங்களைப் புதுப்பிக்கவும்.',
      save: 'மாற்றங்களைச் சேமி',
      saving: 'சேமிக்கிறது…',
      saveFailed: 'மாற்றங்களைச் சேமிக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.',
    },
    editDetails: 'விவரங்களைத் திருத்து',
    startConsultation: 'ஆலோசனையைத் தொடங்கு',
    allergyFlag: 'ஒவ்வாமை · {{substance}}',
    bloodFlag: 'இரத்தம் {{group}}',
    pregnantFlag: 'கர்ப்பம் · {{poa}}',
    noKnownAllergies: 'அறியப்பட்ட ஒவ்வாமைகள் பதிவு செய்யப்படவில்லை.',
    cardAllergies: 'ஒவ்வாமைகள்',
    cardChronicDiseases: 'நாள்பட்ட நோய்கள்',
    cardCurrentMeds: 'தற்போதைய மருந்துகள்',
    cardPastMedical: 'கடந்த மருத்துவ & அறுவை',
    cardObstetric: 'மகப்பேறு சுருக்கம்',
    cardFamilySocial: 'குடும்பம் & சமூகம்',
    cardVisitTimeline: 'வருகை காலவரிசை',
    familyLabel: 'குடும்பம்',
    socialLabel: 'சமூகம்',
    noChronicDiseases: 'நாள்பட்ட நோய்கள் பதிவு செய்யப்படவில்லை.',
    noCurrentMeds: 'தற்போதைய மருந்துகள் பதிவு செய்யப்படவில்லை.',
    noPastHistory: 'கடந்த மருத்துவ அல்லது அறுவை வரலாறு பதிவு செய்யப்படவில்லை.',
    noFamilySocial: 'குடும்ப அல்லது சமூக வரலாறு பதிவு செய்யப்படவில்லை.',
    sinceYear: '{{year}} முதல்',
    obGravidaPara: 'கர்ப்பம் / பிரசவம்',
    obPoaLabel: 'POA',
    obTrimester: 'மூன்று மாத காலம்',
    obLmp: 'LMP',
    obEdd: 'EDD',
    obPoa: 'POA {{poa}}',
    obWeeksDays: '{{weeks}}வா {{days}}நா',
    obFullTerm: 'EDD 40வா',
    obTrimesterValue: '{{n}}',
    noVisitsYet: 'இன்னும் வருகைகள் இல்லை',
    noVisitsBody: 'இந்த நோயாளியின் ஆலோசனைகள் இங்கே தோன்றும்.',
    statusDraft: 'வரைவு',
    statusFinalized: 'இறுதி செய்யப்பட்டது',
    visitNoDiagnosis: 'ஆலோசனை',
    // வருகையின் தொடர்புடைய காலம் (visitRecency.ts ஐப் பார்க்கவும்).
    visitToday: 'இன்று',
    visitYesterday: 'நேற்று',
    visitDaysAgo_one: '{{count}} நாளுக்கு முன்',
    visitDaysAgo_other: '{{count}} நாட்களுக்கு முன்',
    visitWeeksAgo_one: '{{count}} வாரத்திற்கு முன்',
    visitWeeksAgo_other: '{{count}} வாரங்களுக்கு முன்',
    visitMonthsAgo_one: '{{count}} மாதத்திற்கு முன்',
    visitMonthsAgo_other: '{{count}} மாதங்களுக்கு முன்',
    visitYearsAgo_one: '{{count}} ஆண்டுக்கு முன்',
    visitYearsAgo_other: '{{count}} ஆண்டுகளுக்கு முன்',
    couldNotLoadHistory: 'மருத்துவ வரலாற்றை ஏற்ற முடியவில்லை.',
    couldNotLoadVisits: 'வருகைகளை ஏற்ற முடியவில்லை.',
    // ஒரு வருகையின் தரவுச் சுருக்கம் (read-only).
    visitSummary: {
      cardDispensed: 'மருத்துவமனையில் வழங்கிய மருந்துகள்',
      cardOutside: 'வெளியில் வாங்க வேண்டிய மருந்துகள்',
      cardPlan: 'திட்டம் & மேலாண்மை',
      cardMeds: 'இந்த வருகையின் மருந்துகள்',
      cardObstetric: 'மகப்பேறு & பெண்நோய்',
      gestation: 'கர்ப்ப காலம்',
      gestationWeeks_one: '{{count}} வாரம்',
      gestationWeeks_other: '{{count}} வாரங்கள்',
      withinDays_one: '{{count}} நாளுக்குள்',
      withinDays_other: '{{count}} நாட்களுக்குள்',
      followUp_one: '{{count}} நாளில் திரும்பவும்',
      followUp_other: '{{count}} நாட்களில் திரும்பவும்',
      noFollowUp: 'மறுபரிசோதனை இல்லை',
      continueEditing: 'திருத்தத்தைத் தொடரவும்',
    },
  },

  // Phase 2 consultation form (chrome only in P2-1).
  consult: {
    consultation: 'ஆலோசனை',
    stageOfM: 'நிலை {{n}} / {{total}}',
    stepperLabel: 'ஆலோசனை நிலைகள்',
    back: 'பின்செல்',
    saveDraft: 'வரைவைச் சேமி',
    reviewAndSave: 'மதிப்பாய்வு செய்து சேமி',
    review: 'மதிப்பாய்வு',
    jumpToStage: 'நிலைக்குச் செல்',
    nextShort: 'அடுத்து · {{stage}}',
    saveConsultation: 'ஆலோசனையைச் சேமி',
    notMandatory: 'இங்கு எதுவும் கட்டாயமில்லை — பகுதி சேமிப்புகள் சரி',
    readOnly: 'இறுதிசெய்யப்பட்டது — படிக்க மட்டும்',
    placeholderBody: '{{stage}} — பின்னர் சேர்க்கப்படும்.',
    stepInProgress: 'நடந்து கொண்டிருக்கிறது',
    stepDone: 'முடிந்தது',
    stepFinal: 'இறுதி படி',
    stepEmpty: 'காலியானது',
    saving: 'சேமிக்கிறது…',
    saved: 'சேமிக்கப்பட்டது',
    savedAt: '{{time}} இல் சேமிக்கப்பட்டது',
    saveFailed: 'சேமிக்க முடியவில்லை',
    conflictTitle: 'இந்த வரைவு வேறிடத்தில் மாற்றப்பட்டது',
    conflictBody:
      'யாரோ இந்த ஆலோசனையை மற்றொரு சாளரத்தில் புதுப்பித்துள்ளனர். உங்கள் மாற்றங்கள் வைக்கப்பட்டுள்ளன — சமீபத்திய பதிப்பைப் பெற மீண்டும் ஏற்றவும்.',
    reload: 'மீண்டும் ஏற்று',
    reloading: 'மீண்டும் ஏற்றுகிறது…',
    couldNotLoad: 'ஆலோசனையை ஏற்ற முடியவில்லை',
    notFound: 'இந்த ஆலோசனையைக் கண்டறிய முடியவில்லை.',
    stage: {
      presenting: {
        label: 'தற்போதைய புகார் & அமைப்பு மதிப்பாய்வு',
        short: 'புகார்',
        sub: 'புகாரைப் பதிவு செய்து, அமைப்புகளை மதிப்பாய்வு செய்யவும். ஒவ்வொரு அமைப்பும் இயல்பாக இருக்கும் — நேர்மறை கண்டுபிடிப்புகள் உள்ளவற்றை மட்டும் திறக்கவும்.',
      },
      past: {
        label: 'கடந்த மருத்துவ & அறுவை சிகிச்சை வரலாறு',
        short: 'கடந்த வ.',
        sub: 'முன்னெடுக்கப்பட்ட நிலைமைகளை உறுதிப்படுத்தவும். நாள்பட்ட நோய்களுக்கு மருந்துகளை இணைக்கலாம்.',
      },
      obstetric: {
        label: 'மகளிர் & மகப்பேறு வரலாறு',
        short: 'மகளிர்/மகப்',
        sub: 'நோயாளி பெண் என்பதால் காட்டப்படுகிறது. LMP gestogram, POA மற்றும் EDD ஐ இயக்குகிறது.',
      },
      drugs: {
        label: 'மருந்து வரலாறு & ஒவ்வாமைகள்',
        short: 'மருந்துகள்',
        sub: 'தற்போதைய மருந்துகள் மற்றும் அறியப்பட்ட மருந்து ஒவ்வாமைகள்.',
      },
      family: {
        label: 'குடும்ப வரலாறு',
        short: 'குடும்பம்',
        sub: 'பரம்பரை மற்றும் குடும்ப நிலைமைகள்.',
      },
      social: {
        label: 'சமூக வரலாறு',
        short: 'சமூகம்',
        sub: 'புகைபிடித்தல், மது, தொழில் மற்றும் வாழ்க்கை முறை.',
      },
      review: {
        label: 'மதிப்பாய்வு செய்து சேமி',
        short: 'மதிப்பாய்வு',
        sub: 'பதிவு செய்த அனைத்தையும் மதிப்பாய்வு செய்து ஆலோசனையை இறுதிசெய்யவும்.',
      },
    },
    systems: {
      cardiovascular: 'இதய நாள',
      respiratory: 'சுவாச',
      gastrointestinal: 'இரைப்பை குடல்',
      genitourinary: 'இனப்பெருக்க சிறுநீர',
      neurological: 'நரம்பியல்',
      musculoskeletal: 'தசை எலும்பு',
      dermatological: 'தோல்',
      endocrine: 'நாளமில்லா',
    },
    gestogram: {
      emptyHint: 'கர்ப்ப தேதியைக் காண LMP ஐ உள்ளிடவும்.',
      lmp: 'LMP',
      entered: 'உள்ளிட்டது',
      poa: 'இன்று POA',
      poaValue: '{{weeks}}வா {{days}}நா',
      edd: 'EDD',
      naegele: 'Naegele +280d',
      manual: 'கையேடு',
      trimester: 'மூன்று மாதம்',
      triValue: '{{n}}',
      tri1: '1வது மூன்று மாதம்',
      tri2: '2வது மூன்று மாதம்',
      tri3: '3வது மூன்று மாதம்',
      autoBadge: 'தானியங்கி',
      manualBadge: 'கையேடு',
      pastEdd: 'EDD ஐ தாண்டிவிட்டது — கர்ப்பம் தொடர்கிறதா என உறுதிப்படுத்தவும்.',
      pastTerm: 'கால அளவைத் தாண்டியது — இந்தக் கர்ப்பம் முடிந்திருக்கலாம். விளைவைப் பதிவு செய்யவும் அல்லது LMP ஐப் புதுப்பிக்கவும்.',
      editEdd: 'EDD திருத்து',
      revertEdd: 'EDD ஐ தானியங்கிக்கு மீட்டமை',
      eddLabel: 'EDD',
      editPoa: 'POA வாரங்களைத் திருத்து',
      revertPoa: 'POA ஐ தானியங்கிக்கு மீட்டமை',
      poaWeeksLabel: 'POA (வாரங்கள்)',
      weekShort: '{{n}}வா',
      milestone: {
        tri1End: '1வது மூன்று மாதம் முடிவு',
        anatomy: 'உடற்கூறு ஸ்கேன்',
        viability: 'உயிர்வாழ்தகவு',
        term: 'முழு கால',
        edd: 'EDD',
      },
    },
    obstetric: {
      gynaecology: 'மகளிர் மருத்துவம்',
      obstetric: 'மகப்பேறு',
      prefilled: 'உறுதிப்படுத்தப்பட்டது',
      lmp: 'LMP',
      lmpHint: 'கீழே உள்ள gestogram, POA மற்றும் EDD ஐ இயக்குகிறது.',
      gestogramLabel: 'LMP மூலம் Gestogram',
      contraception: 'கருத்தடை',
      cycleNotes: 'மாதவிடாய் முறை, சுழற்சி மற்றும் முதல் மாதவிடாய்',
      cycleNotesHint: 'சுயவிளக்கம் — எ.கா. வழக்கமான 28 நாள் சுழற்சி, இயல்பான ஓட்டம், முதல் மாதவிடாய் 13.',
      cycleNotesPlaceholder: 'வழக்கமான 28 நாள் சுழற்சி, இயல்பான ஓட்டம், 13 வயதில் முதல் மாதவிடாய்…',
      gynaeNotes: 'கர்ப்பப்பை வாய் பரிசோதனை மற்றும் அறியப்பட்ட மகளிர் பிரச்சினைகள்',
      gynaeNotesHint: 'சுயவிளக்கம் — கடைசி பரிசோதனை தேதி மற்றும் ஏதேனும் மகளிர் நிலைமைகள்.',
      gynaeNotesPlaceholder: 'கடைசி கர்ப்பப்பை வாய் பரிசோதனை மார்ச் 2024, அறியப்பட்ட மகளிர் பிரச்சினைகள் இல்லை…',
      parity: 'பேறு பதிவு',
      gravida: 'Gravida',
      para: 'Para',
      increment: '{{field}} ஐ அதிகரி',
      decrement: '{{field}} ஐ குறை',
      pregnancies: 'முந்தைய கர்ப்பங்கள்',
      noPregnancies: 'இன்னும் கர்ப்பங்கள் பதிவு செய்யப்படவில்லை.',
      addPregnancy: 'கர்ப்பத்தைச் சேர்',
      autoRecorded: 'தானியங்கி',
      autoRecordedHint: 'இந்தக் கர்ப்பம் கால அளவைத் தாண்டியபோது தானாகப் பதிவு செய்யப்பட்டது — விவரங்களை உறுதிப்படுத்தவும் அல்லது அகற்றவும்.',
      removePregnancy: 'கர்ப்பம் {{n}} ஐ அகற்று',
      year: 'ஆண்டு',
      mode: 'முறை',
      outcome: 'விளைவு',
      complications: 'இந்த கர்ப்பத்தின் சிக்கல்கள்',
      complicationsHint: 'தற்போதைய கர்ப்ப ஸ்னாப்ஷாட்டுடன் பதிவு செய்யப்படுகிறது.',
    },
    // Systemic review & plan stage.
    presenting: {
      systemicReview: 'அமைப்பு மறுஆய்வு',
      systemsFlagged: '{{total}} இல் {{count}} அமைப்புகள் குறிக்கப்பட்டுள்ளன',
      systemFindings: 'புகார்கள்',
      findingPlaceholder: 'புகாரைத் தேடவும் அல்லது சேர்க்கவும்…',
      systemNote: 'குறிப்பு',
      systemNotePlaceholder: 'இந்த அமைப்புக்கு ஒரு குறிப்பைச் சேர்க்கவும்…',
      diagnosis: 'நோயறிதல்',
      diagnosisHint: 'இந்த வருகைக்கான நோயறிதல்களைத் தேடவும் அல்லது சேர்க்கவும்.',
      diagnosisPlaceholder: 'நோயறிதலைத் தேடவும் அல்லது சேர்க்கவும்…',
      // Plan / management (per-visit).
      followUp: 'மறுபரிசோதனை',
      followUpHint: 'நோயாளி மீண்டும் வர எத்தனை நாட்கள்.',
      followUpDaysShort: 'நாட்கள்',
      followUpPlaceholder: 'எ.கா. 7',
      investigations: 'பரிசோதனைகள்',
      investigationsHint: 'பரிந்துரைக்கப்பட்ட பரிசோதனைகள், ஒவ்வொன்றுக்கும் விருப்ப கால அளவு.',
      investigationPlaceholder: 'பரிசோதனையைத் தேடவும் அல்லது சேர்க்கவும்…',
      addInvestigationNamed: '“{{name}}” பரிசோதனையைச் சேர்க்கவும்',
      removeInvestigation: '{{name}} பரிசோதனையை அகற்றவும்',
      noInvestigations: 'இன்னும் பரிசோதனைகள் பரிந்துரைக்கப்படவில்லை.',
      withinDays: 'நாட்களுக்குள்',
      withinDaysShort: 'நாட்களுக்குள்',
      referrals: 'பரிந்துரைகள்',
      referralsHint: 'பரிந்துரை இடங்களைத் தேடவும் அல்லது சேர்க்கவும்.',
      referralPlaceholder: 'பரிந்துரையைத் தேடவும் அல்லது சேர்க்கவும்…',
    },
    // Past medical & surgical stage.
    past: {
      prefilled: 'உறுதிப்படுத்தப்பட்டது',
      previousIllnesses: 'முந்தைய நோய்கள்',
      previousIllnessesHint: 'கடந்த கால நோய்கள் மற்றும் தீர்க்கப்பட்ட நிலைமைகள்.',
      previousIllnessPlaceholder: 'முந்தைய நோயைத் தேடவும் அல்லது சேர்க்கவும்…',
      chronic: 'நாள்பட்ட / தொற்றா நோய்கள்',
      chronicHint: 'நோயாளிக்கு உள்ள நிலைமைகளைத் தேர்ந்தெடுக்கவும்.',
      surgeries: 'பெரிய அறுவை சிகிச்சைகள்',
      surgeriesHint: 'விருப்ப ஆண்டுடன் கூடிய செயல்முறை.',
      procedure: 'செயல்முறை',
      procedurePlaceholder: 'எ.கா. குடல்வால் அறுவை',
      year: 'ஆண்டு',
      addSurgery: 'அறுவை சிகிச்சையைச் சேர்க்கவும்',
      removeSurgery: '{{name}} அறுவை சிகிச்சையை அகற்றவும்',
      noSurgeries: 'இன்னும் அறுவை சிகிச்சைகள் பதிவு செய்யப்படவில்லை.',
      bloodTransfusion: 'இரத்தமாற்றம்',
      significantTrauma: 'குறிப்பிடத்தக்க காயம்',
    },
    // Drug history & allergies stage.
    drugs: {
      prefilled: 'உறுதிப்படுத்தப்பட்டது',
      currentMedication: 'தற்போதைய மருந்து',
      currentMedicationHint: 'ஒவ்வொரு உள்ளீடும் ஒரு டோஸ் மற்றும் அதிர்வெண்ணை எடுக்கும்.',
      addMedication: 'மருந்தைச் சேர்க்கவும்',
      removeMedication: '{{drug}} ஐ அகற்றவும்',
      noMedications: 'இன்னும் தற்போதைய மருந்துகள் பதிவு செய்யப்படவில்லை.',
      dose: 'டோஸ்',
      dosePlaceholder: 'எ.கா. 500 mg',
      frequency: 'அதிர்வெண்',
      frequencyPlaceholder: 'எ.கா. BD',
      adviceCompliance: 'சிகிச்சை இணக்கம்',
      adviceComplianceHint: 'மருத்துவரின் ஆலோசனை மற்றும் பரிந்துரைக்கப்பட்ட சிகிச்சைக்கு ஒட்டுமொத்த இணக்கம்.',
      complianceGood: 'நல்லது',
      compliancePartial: 'பகுதி',
      compliancePoor: 'மோசம்',
      allergies: 'மருந்து ஒவ்வாமைகள்',
      allergiesHint: 'நோயாளி சுருக்கத்தில் சிவப்பு ஒவ்வாமை கொடியாகத் தோன்றும்.',
      allergySubstance: 'பொருள்',
      allergySubstancePlaceholder: 'ஒரு பொருளைத் தேடவும் அல்லது சேர்க்கவும்…',
      allergyReaction: 'எதிர்வினை',
      allergyReactionPlaceholder: 'எ.கா. தடிப்பு',
      allergySeverity: 'தீவிரம்',
      severityMild: 'லேசான',
      severityModerate: 'மிதமான',
      severitySevere: 'கடுமையான',
      addAllergy: 'ஒவ்வாமையைச் சேர்க்கவும்',
      removeAllergy: '{{name}} ஒவ்வாமையை அகற்றவும்',
      noAllergies: 'மருந்து ஒவ்வாமைகள் பதிவு செய்யப்படவில்லை.',
    },
    // Family history stage.
    family: {
      prefilled: 'உறுதி',
      hereditary: 'பரம்பரை நோய்கள்',
      hereditaryHint: 'குடும்பத்தில் பரவும் நிலைமைகள்.',
      relatives: 'குடும்ப உறுப்பினர்களின் ஒத்த நோய்கள்',
      relativesHint: 'பாதிக்கப்பட்ட உறவினரையும் நோயையும் குறிக்கவும் — எ.கா. தாய் — DM.',
      relativesPlaceholder: 'எ.கா. தாய் — DM…',
      additions: 'பிற சேர்க்கைகள்',
    },
    // Social history stage.
    social: {
      prefilled: 'உறுதி',
      smoking: 'புகைபிடித்தல்',
      smokingNever: 'ஒருபோதும் இல்லை',
      smokingEx: 'முன்னாள் புகைப்பவர்',
      smokingCurrent: 'தற்போதைய',
      alcohol: 'மது பயன்பாடு',
      alcoholNever: 'ஒருபோதும் இல்லை',
      alcoholOccasional: 'எப்போதாவது',
      alcoholRegular: 'வழக்கமான',
      living: 'வாழ்க்கை நிலை',
      livingHint: 'நோயாளி யாருடன் வாழ்கிறார்.',
      occupation: 'தொழில் & வீட்டு குறிப்புகள்',
      occupationHint: 'சுதந்திர உரை — தொழில், வீடு மற்றும் பிற சமூக குறிப்புகள்.',
      occupationPlaceholder: 'ஆசிரியர், சொந்த வீட்டில் வசிக்கிறார்…',
    },
    // Review & save stage.
    reviewSave: {
      edit: 'திருத்து',
      editStage: '{{stage}} திருத்து',
      emptyOptional: 'காலி · விருப்பத்தேர்வு',
      systemsFlagged: '{{count}} அமைப்புகள் குறிக்கப்பட்டன',
      followUpInDays: '{{count}} நாட்களில் மறுபரிசோதனை',
      pregnanciesCount: '{{count}} கர்ப்பங்கள்',
      allergyPrefix: 'ஒவ்வாமை:',
      whatHappens: 'சேமிக்கும்போது என்ன நடக்கும்',
      newVisitTitle: 'புதிய வருகை பதிவு',
      newVisitBody:
        'புகார், அமைப்பு மதிப்பாய்வு, தற்போதைய மருந்துகள் & மகப்பேறு மதிப்புகள் காலவரிசையில் சேர்க்கப்படும்.',
      recordUpdatedTitle: 'பதிவு புதுப்பிக்கப்பட்டது',
      recordUpdatedBody:
        'ஒவ்வாமைகள், நாட்பட்ட நோய்கள், அறுவைசிகிச்சைகள் & அடிப்படைகள் புதுப்பிக்கப்படும், அடுத்த வருகை முன்நிரப்பும்.',
      finalizeHint: 'இறுதி செய்ய கீழே “ஆலோசனையை சேமி” பயன்படுத்தவும். இங்கு எதுவும் கட்டாயமில்லை.',
    },
  },

  lab: {
    title: 'ஆய்வகப் பணிப்பட்டியல்',
    subtitle: 'சேகரிக்கப்பட்ட மாதிரிகளும் வரவிருக்கும் அறிக்கைகளும்.',
    reportsTitle: 'ஆய்வக அறிக்கைகள்',
    reportsSubtitle: 'பெறப்பட்ட அனைத்து அறிக்கைகளும், புதியது முதலில்.',
    accession: 'அணுகல் எண்',
    orderedBy: 'ஆணையிட்டவர்',
    external: 'வெளியில் இருந்து',
    priority: { routine: 'வழக்கமான', urgent: 'அவசர' },
    specimen: { blood: 'இரத்தம்', urine: 'சிறுநீர்', stool: 'மலம்', other: 'மற்றவை' },
    status: {
      awaiting_collection: 'எடுக்க வேண்டியவை',
      recollect_required: 'மீண்டும் எடுக்க வேண்டும்',
      collected: 'ஆய்வகத்தில்',
      partially_resulted: 'பகுதியளவு முடிவுகள்',
      resulted: 'முடிவுகள் வந்துவிட்டன',
      cancelled: 'ரத்து செய்யப்பட்டது',
    },
    segment: {
      toCollect: 'எடுக்க வேண்டியவை',
      inLab: 'ஆய்வகத்தில்',
      resulted: 'முடிவுகள் வந்தவை',
      all: 'அனைத்தும்',
    },
    filterLabel: 'நிலை அடிப்படையில் வடிகட்டு',
    laboratory: 'ஆய்வகம்',
    laboratoryUnset: 'அமைக்கப்படவில்லை',
    allLaboratories: 'அனைத்து ஆய்வகங்களும்',
    noLaboratory: 'ஆய்வகம் அமைக்கப்படவில்லை',
    filterLaboratory: 'ஆய்வகம் அடிப்படையில் வடிகட்டு',
    searchLabel: 'ஆய்வக ஆணைகளைத் தேடு',
    searchPlaceholder: 'நோயாளியின் பெயர் அல்லது அணுகல் எண்',
    showCancelled: 'ரத்து செய்யப்பட்டவற்றைக் காட்டு',
    dateFrom: 'முதல்',
    dateTo: 'வரை',
    today: 'இன்று',
    newOrder: 'புதிய ஆய்வக ஆணை',
    testCount_one: '{{count}} பரிசோதனை',
    testCount_other: '{{count}} பரிசோதனைகள்',
    capNotice:
      'இந்த வரம்பில் முதல் {{count}} ஆணைகள் காட்டப்படுகின்றன. மீதியைப் பார்க்கத் தேதி வரம்பைக் குறுக்குங்கள்.',
    emptyToCollect: 'எடுக்க வேண்டிய மாதிரிகள் எதுவும் இல்லை.',
    emptyInLab: 'ஆய்வகத்தில் காத்திருப்பவை எதுவும் இல்லை.',
    emptyResulted: 'இந்த வரம்பில் வந்த அறிக்கைகள் இல்லை.',
    emptyAll: 'இந்த வரம்பில் ஆய்வக ஆணைகள் இல்லை.',
    emptyReports: 'பொருந்தும் அறிக்கைகள் இல்லை.',
    loadFailed: 'ஆய்வக ஆணைகளை ஏற்ற முடியவில்லை.',
    reportsLoadFailed: 'அறிக்கைகளை ஏற்ற முடியவில்லை.',
    collectedAt: 'எடுத்த நேரம்',
    notCollected: 'எடுக்கப்படவில்லை',
    rejected: 'நிராகரிக்கப்பட்டது',
    openOrder: '{{accession}} ஆணையைத் திற',
    openReport: 'அறிக்கையைத் திற',
    reportFor: '{{test}} அறிக்கை',
    uploadedBy: 'பதிவேற்றியவர்',
    supersededBadge: 'மாற்றப்பட்டது',
    removedBadge: 'நீக்கப்பட்டது',
    detail: {
      back: 'பணிப்பட்டியலுக்குத் திரும்பு',
      loadFailed: 'இந்த ஆணையை ஏற்ற முடியவில்லை.',
      notFound: 'அந்த ஆய்வக ஆணை இனி இல்லை.',
      indication: 'காரணம்',
      changeLaboratory: 'ஆய்வகத்தை மாற்று',
      laboratorySaveFailed: 'ஆய்வகத்தை மாற்ற முடியவில்லை.',
      specimens: 'மாதிரிகள்',
      tests: 'பரிசோதனைகள்',
      reports: 'அறிக்கைகள்',
      noSpecimens: 'இதுவரை மாதிரி எதுவும் பதிவு செய்யப்படவில்லை.',
      collect: 'மாதிரியைப் பதிவு செய்',
      collectType: '{{type}} மாதிரியைப் பதிவு செய்',
      recollect: 'மீண்டும் எடு',
      reject: 'மாதிரியை நிராகரி',
      rejectTitle: 'இந்த {{type}} மாதிரியை நிராகரிக்கவா?',
      rejectExplain:
        'இந்த மாதிரியின் பரிசோதனைகள் மீண்டும் மாதிரி எடுக்கும் வரிசைக்குச் செல்லும். நிராகரிக்கப்பட்ட மாதிரி பதிவில் இருக்கும்.',
      rejectReason: 'காரணம்',
      rejectNote: 'குறிப்பு',
      rejectConfirm: 'மாதிரியை நிராகரி',
      rejectedBecause: 'நிராகரிக்கப்பட்டது — {{reason}}',
      reason: {
        haemolysed: 'இரத்த அணுக்கள் உடைந்துள்ளன',
        insufficient: 'அளவு போதுமானதாக இல்லை',
        clotted: 'உறைந்துவிட்டது',
        mislabelled: 'லேபிள் தவறானது',
        leaked: 'கசிந்துவிட்டது',
        contaminated: 'மாசடைந்துள்ளது',
        other: 'மற்றவை',
      },
      cancelOrder: 'ஆணையை ரத்து செய்',
      cancelOrderTitle: 'இந்த ஆணையை ரத்து செய்யவா?',
      cancelOrderExplain: 'உங்கள் காரணத்துடன் ஆணை பதிவில் இருக்கும்.',
      cancelTest: 'பரிசோதனையை ரத்து செய்',
      cancelTestTitle: '{{test}} ரத்து செய்யவா?',
      cancelReasonLabel: 'காரணம்',
      cancelledBecause: 'ரத்து செய்யப்பட்டது — {{reason}}',
      awaitingReport: 'அறிக்கைக்குக் காத்திருக்கிறது',
      uploadReport: 'அறிக்கையைப் பதிவேற்று',
      replaceReport: 'அறிக்கையை மாற்று',
      uploading: 'பதிவேற்றுகிறது…',
      uploadCancel: 'பதிவேற்றத்தை நிறுத்து',
      chooseFile: 'ஒரு PDF ஐத் தேர்வு செய்',
      dropHint: 'ஒரு PDF ஐ இங்கே இடுங்கள், அல்லது கோப்பைத் தேர்வு செய்யுங்கள்.',
      notPdf: 'அது PDF அல்ல. ஆய்வக அறிக்கைகள் PDF ஆக இருக்க வேண்டும்.',
      tooLarge: 'அந்தக் கோப்பு 20 MB ஐ விட பெரியது. ஆய்வகத்திடம் சிறிய நகலைக் கேளுங்கள்.',
      emptyFile: 'அந்தக் கோப்பு காலியாக உள்ளது.',
      uploadFailed: 'அறிக்கையைப் பதிவேற்ற முடியவில்லை.',
      duplicateWarning: 'இது ஏற்கெனவே இந்த ஆணையுடன் இணைக்கப்பட்ட கோப்பு போலத் தெரிகிறது.',
      conflictTitle: 'வேறு ஒருவர் ஒரு அறிக்கையைப் பதிவேற்றியுள்ளார்',
      conflictExplain:
        'நீங்கள் வேலை செய்யும் போது இந்தப் பரிசோதனைக்கு ஒரு அறிக்கை பதிவேற்றப்பட்டது. மாற்றினால் இரண்டும் பதிவில் இருக்கும்.',
      replaceAnyway: 'எப்படியும் மாற்று',
      removeReport: 'அறிக்கையை நீக்கு',
      removeReportTitle: 'இந்த அறிக்கையை நீக்கவா?',
      removeReportExplain:
        'பரிசோதனை மீண்டும் அறிக்கைக்குக் காத்திருக்கும். கோப்பு அழிக்கப்படாமல் பதிவில் வைக்கப்படும்.',
      openFailed: 'அறிக்கையைத் திறக்க முடியவில்லை.',
      noReports: 'இதுவரை அறிக்கைகள் இல்லை.',
      offlineUpload: 'அறிக்கையைப் பதிவேற்ற இணைப்பு தேவை.',
    },
    noReportAccess: 'அறிக்கைகளைத் திறக்க உங்களுக்கு அனுமதி இல்லை.',
    config: {
      title: 'ஆய்வக அமைப்பு',
      subtitle:
        'ஆய்வகப் பிரிவின் அடிப்படைத் தரவு: நீங்கள் செய்யும் பரிசோதனைகளும் பயன்படுத்தும் ஆய்வகங்களும்.',
      tabsLabel: 'ஒரு பட்டியலைத் தேர்வுசெய்க',
    },
    catalogue: {
      title: 'பரிசோதனைப் பட்டியல்',
      subtitle: 'இந்த மருத்துவமனை செய்யும் பரிசோதனைகள். உள்ளமைந்தவை மற்றும் உங்களுடையவை.',
      addTitle: 'ஒரு பரிசோதனையைச் சேர்',
      name: 'பெயர்',
      code: 'குறியீடு',
      codeHint: 'சுருக்கமாக இருக்க வேண்டும், மீண்டும் பயன்படுத்தக் கூடாது.',
      specimen: 'மாதிரி',
      container: 'கலன்',
      preset: 'உள்ளமைந்தது',
      custom: 'உங்களுடையது',
      hidden: 'மறைக்கப்பட்டது',
      hide: 'மறை',
      show: 'காட்டு',
      hideTest: '{{test}} மறை',
      showTest: '{{test}} காட்டு',
      suggestionsTitle: 'முந்தைய ஆணைகளில் தட்டச்சு செய்யப்பட்டவை',
      suggestionsHint: 'பணியாளர்கள் கையால் தட்டச்சு செய்த பெயர்கள். மீண்டும் தட்டச்சு செய்வதைத் தவிர்க்கப் பட்டியலில் சேர்க்கவும்.',
      errors: {
        incomplete: 'ஒரு பரிசோதனைக்குப் பெயரும் குறியீடும் தேவை.',
        duplicate: 'அந்தக் குறியீடு ஏற்கெனவே பட்டியலில் உள்ளது.',
        saveFailed: 'அந்த மாற்றத்தைச் சேமிக்க முடியவில்லை.',
      },
    },
    laboratories: {
      title: 'ஆய்வகங்கள்',
      subtitle:
        'இந்த மருத்துவமனை வேலை அனுப்பும் ஆய்வகங்கள். நோயாளிகளுக்கு ஒருபோதும் காட்டப்படாது.',
      addTitle: 'ஆய்வகத்தைச் சேர்க்கவும்',
      name: 'ஆய்வகத்தின் பெயர்',
      rename: 'பெயர் மாற்று',
      renameLab: '{{lab}} பெயர் மாற்று',
      hidden: 'மறைக்கப்பட்டது',
      hide: 'மறை',
      show: 'காட்டு',
      hideLab: '{{lab}} மறை',
      showLab: '{{lab}} காட்டு',
      empty: 'இன்னும் ஆய்வகங்கள் இல்லை.',
      inUseHint:
        'ஒரு ஆய்வகத்தை மறைத்தால் பழைய ஆணைகளில் அது இருக்கும்; புதிய ஆணைகளில் மட்டும் தோன்றாது.',
      loadFailed: 'ஆய்வகங்களை ஏற்ற முடியவில்லை.',
      errors: {
        incomplete: 'ஆய்வகத்திற்கு ஒரு பெயர் தேவை.',
        duplicate: 'அந்த ஆய்வகம் ஏற்கெனவே பட்டியலில் உள்ளது.',
        saveFailed: 'அந்த மாற்றத்தைச் சேமிக்க முடியவில்லை.',
      },
    },
    reports: {
      searchLabel: 'அறிக்கைகளைத் தேடு',
      testFilter: 'பரிசோதனை',
      allTests: 'அனைத்துப் பரிசோதனைகளும்',
      page: 'பக்கம் {{page}}',
      scopedToPatient: '{{name}} அவர்களுக்கான அறிக்கைகள்',
      thisPatient: 'இந்த நோயாளி',
      clearPatientScope: 'அனைத்து நோயாளிகளின் அறிக்கைகளையும் காட்டு',
    },
    patient: {
      title: 'ஆய்வகம்',
      empty: 'இதுவரை ஆய்வக ஆணைகள் இல்லை.',
      loadFailed: 'இந்த நோயாளியின் ஆய்வக ஆணைகளை ஏற்ற முடியவில்லை.',
      seeAll: 'அனைத்து அறிக்கைகளையும் பார்',
      reportOnFile: 'அறிக்கை கோப்பில் உள்ளது',
    },
    new: {
      title: 'புதிய ஆய்வக ஆணை',
      stepPatient: 'நோயாளி',
      stepTests: 'பரிசோதனைகள்',
      stepCollection: 'மாதிரி எடுத்தல்',
      next: 'தொடரவும்',
      back: 'பின்செல்',
      submit: 'ஆணையை உருவாக்கு',
      saving: 'உருவாக்குகிறது…',
      submitFailed: 'ஆணையை உருவாக்க முடியவில்லை.',
      patientChosen: 'நோயாளி',
      changePatient: 'வேறு ஒருவரைத் தேர்ந்தெடு',
      choosePatient: 'நோயாளியைத் தேர்ந்தெடு',
      patientLoadFailed: 'அந்த நோயாளியின் விவரங்களை ஏற்ற முடியவில்லை.',
      registerPatient: 'புதிய நோயாளியைப் பதிவு செய்',
      filterTests: 'ஒரு பரிசோதனையைத் தேடு',
      filterTestsPlaceholder: 'பெயர் அல்லது குறியீடு',
      noTestsMatch: 'பொருந்தும் பரிசோதனைகள் இல்லை.',
      catalogueFailed: 'பரிசோதனைப் பட்டியலை ஏற்ற முடியவில்லை.',
      willDraw: 'தேவையான மாதிரிகள்',
      drawLine_one: '{{type}} — {{container}} ({{count}} பரிசோதனை)',
      drawLine_other: '{{type}} — {{container}} ({{count}} பரிசோதனைகள்)',
      anyContainer: 'எந்தக் கலனும்',
      chosenCount_one: '{{count}} பரிசோதனை தேர்ந்தெடுக்கப்பட்டது',
      chosenCount_other: '{{count}} பரிசோதனைகள் தேர்ந்தெடுக்கப்பட்டன',
      removeTest: '{{test}} நீக்கு',
      otherTest: 'பட்டியலில் இல்லையா?',
      otherTestName: 'பரிசோதனையின் பெயர்',
      otherTestPlaceholder: 'எ.கா. வைட்டமின் D',
      otherTestType: 'மாதிரி',
      samples: 'மாதிரிகள்',
      collectedType: '{{type}} மாதிரி எடுக்கப்பட்டது',
      collectedAt: 'எடுத்த நேரம்',
      container: 'கலன்',
      labelNote: 'லேபிள் குறிப்பு',
      uncollectedHint:
        'இன்னும் எடுக்கப்படாத மாதிரியைத் தேர்வு செய்யாமல் விடுங்கள் — ஆணை மாதிரி எடுக்கும் வரிசையில் காத்திருக்கும்.',
      priority: 'முன்னுரிமை',
      laboratoryHint: 'இந்த வேலை அனுப்பப்படும் ஆய்வகம். நோயாளிக்குக் காட்டப்படாது.',
      orderedByMe: '{{name}} (நீங்கள்)',
      orderedByExternal: 'இந்த மருத்துவமனைக்கு வெளியே ஒருவர்',
      externalName: 'ஆணையிட்ட மருத்துவர்',
      externalPlaceholder: 'பரிந்துரையில் உள்ள பெயர்',
      indicationPlaceholder: 'இந்தப் பரிசோதனைகள் ஏன் ஆணையிடப்பட்டன',
      errors: {
        noPatient: 'முதலில் ஒரு நோயாளியைத் தேர்ந்தெடுக்கவும்.',
        noTests: 'குறைந்தது ஒரு பரிசோதனையையாவது தேர்ந்தெடுக்கவும்.',
        tooManyTests: 'ஒரு ஆணையில் கொள்ளக்கூடியதை விட அதிக பரிசோதனைகள்.',
        badTime: 'அந்த நேரம் சரியான தேதியும் நேரமும் அல்ல.',
        futureTime: 'மாதிரி எடுத்த நேரம் எதிர்காலத்தில் இருக்க முடியாது.',
        noOrderer: 'இந்தப் பரிசோதனைகளை ஆணையிட்ட மருத்துவரின் பெயரை உள்ளிடவும்.',
        freeText: {
          empty: 'முதலில் பரிசோதனையின் பெயரை உள்ளிடவும்.',
          duplicate: 'அந்தப் பரிசோதனை ஏற்கெனவே இந்த ஆணையில் உள்ளது.',
          full: 'ஒரு ஆணையில் அதிகபட்சம் {{max}} பரிசோதனைகள் மட்டுமே.',
        },
      },
    },
  },

  selectClinic: {
    title: 'ஒரு மருத்துவமனையைத் தேர்வுசெய்க',
    subtitle: '{{name}} ஆக உள்நுழைந்துள்ளீர்கள்',
    yourClinics: 'உங்கள் மருத்துவமனைகள்',
    invitations: 'அழைப்புகள்',
    acceptJoin: 'ஏற்று இணைக',
    createAnother: 'புதிய மருந்தகத்தை உருவாக்கு',
    errAcceptFailed: 'அந்த மருத்துவமனையில் இணைய முடியவில்லை. மீண்டும் முயற்சிக்கவும்.',
    disabled: 'முடக்கப்பட்டது',
    disabledHint: 'தளத்தால் முடக்கப்பட்டுள்ளது. உங்கள் நிர்வாகியைத் தொடர்பு கொள்ளவும்.',
    platformAdmin: 'தள நிர்வாகம்',
  },

  nav: {
    consulting: 'இப்போது பார்க்கும் நோயாளி',
    recordVisit: 'வருகையைப் பதிவு செய்',
    lab: 'ஆய்வகம்',
    labWorklist: 'பணிப்பட்டியல்',
    labReports: 'அறிக்கைகள்',
    labConfig: 'ஆய்வக அமைப்பு',
    workspace: 'பணியிடம்',
    allClinics: 'அனைத்து மருத்துவமனைகள்',
    switchClinic: 'மருத்துவமனையை மாற்று',
    views: 'காட்சிகள்',
    openMenu: 'பட்டியலைத் திற',
    closeMenu: 'பட்டியலை மூடு',
    navigation: 'வழிசெலுத்தல்',
    home: 'முகப்பு',
    patients: 'நோயாளிகள்',
    aptCounter: 'சந்திப்பு கவுண்டர்',
    stock: 'சரக்கு',
    addStock: 'சரக்கு சேர்',
    issue: 'வழங்கல்',
    adjust: 'சரிசெய்',
    activity: 'செயல்பாடு',
    people: 'நபர்கள்',
    auditLog: 'தணிக்கை பதிவு',
    roles: 'பாத்திரங்கள்',
    issuingAnalytics: 'வழங்கல்கள்',
    appointments: 'சந்திப்புகள்',
    stocks: 'சரக்குகள்',
    admin: 'நிர்வாகி',
    staffView: 'பணியாளர்',
    doctorView: 'மருத்துவர்',
    registry: 'பதிவேடு',
  },

  registry: {
    title: 'நோயாளர் பதிவேடு',
    selectTitle: 'ஒரு நோயாளரைத் தேர்ந்தெடுக்கவும்',
    selectBody: 'விவரங்களைப் பார்க்க பட்டியலில் ஒருவரைத் தேர்ந்தெடுக்கவும், அல்லது புதிய நோயாளரைப் பதிவு செய்யவும்.',
    openFullRecord: 'முழு பதிவைத் திறக்கவும்',
    demographicsOnly: 'மருத்துவ வரலாறு மருத்துவர்களுக்கு மட்டுமே.',
    profile: {
      viewPhoto: 'புகைப்படத்தைப் பார்',
      dateOfBirth: 'பிறந்த தேதி',
      sex: 'பாலினம்',
      phone: 'தொலைபேசி',
      registered: 'பதிவு செய்த தேதி',
    },
  },

  auth: {
    signIn: 'உள்நுழை',
    signingIn: 'உள்நுழைகிறது…',
    signInFailed: 'உள்நுழைவு தோல்வியடைந்தது. மீண்டும் முயற்சிக்கவும்.',
    useStaffCredentials: 'உங்கள் பணியாளர் சான்றுகளைப் பயன்படுத்தவும்.',
    newHere: 'புதிதாக வருகிறீர்களா?',
    createAccount: 'கணக்கை உருவாக்கு',
    alreadyHaveAccount: 'ஏற்கனவே கணக்கு உள்ளதா?',
    createYourAccount: 'உங்கள் கணக்கை உருவாக்கவும்',
    oneLoginCovers: 'ஒரே உள்நுழைவு நீங்கள் இணைந்த ஒவ்வொரு மருந்தகத்தையும் உள்ளடக்கும்.',
    creatingAccount: 'கணக்கு உருவாக்கப்படுகிறது…',
    createAccountFailed: 'உங்கள் கணக்கை உருவாக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.',
    atLeast8: 'குறைந்தது 8 எழுத்துகள்',
    atLeast8Error: 'குறைந்தது 8 எழுத்துகள்.',
    agreeTermsLine:
      'நான் <terms>விதிமுறைகளுக்கும்</terms> மருத்துவ தரவு <policy>கையாளும் கொள்கைக்கும்</policy> ஒப்புக்கொள்கிறேன்.',
    showPassword: 'கடவுச்சொல்லைக் காட்டு',
    hidePassword: 'கடவுச்சொல்லை மறை',
    pwWeak: 'பலவீனம்',
    pwFair: 'சாதாரண',
    pwGood: 'நல்லது',
    pwStrong: 'வலிமை',
    pwPolicy10: 'குறைந்தது 10 எழுத்துகள்',
    pwPolicyMix: 'எழுத்துகள் மற்றும் எண்களின் கலவை',
    pwPolicySymbol: 'ஒரு குறியீடு (பரிந்துரைக்கப்படுகிறது)',
    forgotPasswordLink: 'கடவுச்சொல் மறந்துவிட்டதா?',
    forgotPassword: 'கடவுச்சொல்லை மறந்துவிட்டீர்களா?',
    forgotPasswordBody:
      'உங்கள் பணி மின்னஞ்சலை உள்ளிடுங்கள்; புதிய கடவுச்சொல்லைத் தேர்வுசெய்ய இணைப்பு அனுப்புவோம்.',
    sendResetLink: 'மீட்டமைப்பு இணைப்பை அனுப்பு',
    sendingResetLink: 'அனுப்புகிறது…',
    resetRequestFailed: 'மீட்டமைப்பு இணைப்பை அனுப்ப முடியவில்லை. மீண்டும் முயற்சிக்கவும்.',
    resetLinkSentBody: 'உங்கள் அஞ்சல் பெட்டியைப் பாருங்கள்.',
    resetLinkSentDetail:
      '{{email}} க்கு கணக்கு இருந்தால், மீட்டமைப்பு இணைப்பு அனுப்பப்பட்டுள்ளது. அது ஒரு மணி நேரத்தில் காலாவதியாகும். தெரியவில்லை என்றால் ஸ்பேம் கோப்புறையைப் பாருங்கள்.',
    backToSignIn: 'உள்நுழைவுக்குத் திரும்பு',
    chooseNewPassword: 'புதிய கடவுச்சொல்லைத் தேர்வுசெய்க',
    chooseNewPasswordBody: 'இங்கு முன்பு பயன்படுத்தாத ஒன்றைத் தேர்வுசெய்யுங்கள்.',
    newPassword: 'புதிய கடவுச்சொல்',
    confirmPassword: 'கடவுச்சொல்லை உறுதிப்படுத்துக',
    passwordsDoNotMatch: 'கடவுச்சொற்கள் பொருந்தவில்லை.',
    resetPassword: 'கடவுச்சொல்லை மீட்டமை',
    resettingPassword: 'மீட்டமைக்கிறது…',
    resetFailed: 'கடவுச்சொல்லை மீட்டமைக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.',
    passwordResetDone: 'கடவுச்சொல் புதுப்பிக்கப்பட்டது',
    passwordResetDoneBody: 'இப்போது புதிய கடவுச்சொல்லுடன் உள்நுழையலாம்.',
    resetLinkUnusableBody:
      'இந்த இணைப்பைப் பயன்படுத்த முடியாது. புதிய ஒன்றைக் கோரி மீண்டும் முயற்சிக்கவும்.',
    requestNewResetLink: 'புதிய இணைப்பைக் கோருக',
    resetRejection: {
      invalid: 'இந்த மீட்டமைப்பு இணைப்பு செல்லுபடியாகாது.',
      expired: 'இந்த மீட்டமைப்பு இணைப்பு காலாவதியாகிவிட்டது.',
      used: 'இந்த மீட்டமைப்பு இணைப்பு ஏற்கனவே பயன்படுத்தப்பட்டுவிட்டது.',
    },
    brand: {
      loginHeadingLine1: 'சரக்கு வருகை மற்றும்',
      loginHeadingLine2: 'வழங்கல், பதிவில்.',
      loginBody:
        'ஒவ்வொரு மருத்துவமனையிலும், எந்த சாதனத்திலிருந்தும் தொகுதிகளைப் பெறவும், நோயாளிகளுக்கு பொருட்களை வழங்கவும், கெட்டுப்போன சரக்கை சரிசெய்யவும்.',
      registerHeadingLine1: 'ஒரே Synapse கணக்கு.',
      registerHeadingLine2: 'நீங்கள் பணியாற்றும் ஒவ்வொரு மருந்தகமும்.',
      registerBody:
        'உங்கள் கணக்கை அமைத்த பிறகு, உங்கள் மருத்துவமனைக்காக ஒரு மருந்தகத்தை உருவாக்கலாம் அல்லது ஏற்கனவே இருக்கும் ஒன்றில் சேர அழைப்பை ஏற்கலாம்.',
      featureTrackTitle: 'ஒவ்வொரு தொகுதியையும் கண்காணி',
      featureTrackBody: 'ரசீதுகள், வழங்கல்கள் மற்றும் சரிசெய்தல்கள் — அனைத்தும் தணிக்கை செய்யக்கூடியவை.',
      featureRolesTitle: 'பங்குகள் உட்பொதிக்கப்பட்டுள்ளன',
      featureRolesBody:
        'நிர்வாகிகள் நிர்வகிக்கின்றனர், பணியாளர்கள் வழங்குகின்றனர். மருந்தகங்களுக்கு இடையே மாறவும்.',
      featureCalmTitle: 'பளுவின் கீழ் அமைதி',
      featureCalmBody: 'ஒரு கையால் கையாளக்கூடிய மொபைல் மற்றும் வேகமான மேசை பணிக்காக வடிவமைக்கப்பட்டுள்ளது.',
      forgotHeadingLine1: 'வெளியே தள்ளப்படுவது நடக்கும்.',
      forgotHeadingLine2: 'திரும்ப நுழைவது விரைவானது.',
      forgotBody:
        'ஒரு முறை மட்டும் பயன்படுத்தக்கூடிய இணைப்பை மின்னஞ்சலில் அனுப்புவோம். அது ஒரு மணி நேரம் செயல்படும்; புதியதைக் கோரினால் பழையது ரத்தாகும்.',
    },
  },

  home: {
    quickActions: 'விரைவு செயல்கள்',
    atAGlance: 'ஒரு பார்வையில்',
    recentActivity: 'சமீபத்திய செயல்பாடு',
    summary: 'சுருக்கம்',
    addStockDesc: 'புதிய வரவுகளைப் பதிவு செய்',
    issueDesc: 'கையிருப்பிலிருந்து வழங்கு',
    adjustment: 'சரிசெய்தல்',
    stockStatus: 'சரக்கு நிலை',
    outOfStock: 'கையிருப்பில் இல்லை',
    expiringSoon: 'விரைவில் காலாவதியாகும்',
    items: 'பொருட்கள்',
    onHand: 'கையிருப்பு',
    alreadyExpired: 'ஏற்கனவே {{count}} காலாவதியாகிவிட்டது →',
    couldNotLoadSummary: 'சுருக்கத்தை ஏற்ற முடியவில்லை',
    summaryError: 'சுருக்கத்தை ஏற்ற முடியவில்லை.',
    noAccessTitle: 'உங்களுக்கு இதுவரை எதுவும் ஒதுக்கப்படவில்லை',
    noAccessBody: 'இந்தப் பக்கத்தில் உள்ள எந்தச் செயலும் உங்கள் பணிப்பொறுப்பில் இல்லை. அதைச் சரிசெய்ய உங்கள் மருத்துவமனை நிர்வாகியிடம் கேளுங்கள்.',
    emptyInventoryTitle: 'உங்கள் சரக்கு காலியாக உள்ளது',
    emptyInventoryBody:
      'கையிருப்பில் என்ன உள்ளது மற்றும் என்ன காலாவதியாகிறது என்பதைக் கண்காணிக்க உங்கள் முதல் சரக்கைச் சேர்க்கவும்.',
    kindStockIn: 'சரக்கு வந்தது',
    kindIssue: 'வழங்கப்பட்டது',
    kindAdjustment: 'சரிசெய்தல்',
    by: 'மூலம்',
  },

  addStock: {
    title: 'சரக்கு சேர்',
    subtitle: 'தொகுதியாக வரும் பொருட்களைப் பதிவு செய்க. ஸ்கேன் செய்க அல்லது கைமுறையாக உள்ளிடவும்.',
    scanBarcode: 'பார்கோடு ஸ்கேன் செய்',
    scanHint: 'வேகமான வழி — பொருள் விவரங்களை முன்-நிரப்புகிறது',
    orEnterManually: 'அல்லது கைமுறையாக உள்ளிடவும்',
    orEnterManuallyHint: 'கீழே உள்ள படிவத்தை நிரப்பவும் — அதே முடிவு.',
    itemType: 'பொருள் வகை',
    capturedFromScan: 'ஸ்கேனில் இருந்து பிடிக்கப்பட்டது',
    pastDateHint: 'இந்த தேதி கடந்துவிட்டது',
    unlock: 'திற',
    unlockBarcode: 'பார்கோடை திற',
    chooseFromList: 'பட்டியலில் இருந்து தேர்வு',
    custom: 'தனிப்பயன்…',
    clearForm: 'படிவத்தை அழி',
    updateItem: 'பொருளை புதுப்பி',
    addToBatch: 'தொகுதியில் சேர்',
    thisBatch: 'இந்த தொகுதி',
    noItemsYet: 'இன்னும் பொருட்கள் இல்லை',
    itemsAndUnits: '{{count}} {{itemLabel}} · {{units}} {{unitLabel}}',
    nothingInBatch: 'இந்த தொகுதியில் எதுவும் இல்லை',
    nothingInBatchBody: 'இடதுபுறம் ஒரு பொருளை ஸ்கேன் செய்யவும் அல்லது நிரப்பவும், பின்னர் இங்கே சேர்க்கவும்.',
    addAtLeastOne: 'குறைந்தது ஒரு பொருளை சேர்த்து, சமர்ப்பிக்கவும்.',
    submitWillRegister: 'சமர்ப்பித்தால் அனைத்து {{count}} {{itemLabel}} பெறப்பட்டதாக பதிவாகும்.',
    submitBatch: 'தொகுதியை சமர்ப்பி',
    submitting: 'சமர்ப்பிக்கப்படுகிறது…',
    newSku: 'புதிய SKU',
    batchReceived: 'தொகுதி பெறப்பட்டது',
    batchReceivedBody: '{{count}} {{itemLabel}} · {{units}} {{unitLabel}} உங்கள் சரக்கில் சேர்க்கப்பட்டுள்ளன.',
    startAnotherBatch: 'மற்றொரு தொகுதியைத் தொடங்கு',
    errInvalidEntries: 'ஒன்று அல்லது அதற்கு மேற்பட்ட உள்ளீடுகள் தவறானவை. மறுபரிசீலனை செய்து மீண்டும் முயற்சிக்கவும்.',
    errSubmitFailed: 'தொகுதியை சமர்ப்பிக்க முடியவில்லை. சிறிது நேரத்தில் மீண்டும் முயற்சிக்கவும்.',
    placeholderBrand: 'எ.கா. Panadol',
    placeholderGeneric: 'எ.கா. Paracetamol',
    placeholderStrength: 'எ.கா. 500 mg',
    placeholderBatchNumber: 'எ.கா. PCM-2511-B',
    placeholderBarcode: 'ஸ்கேன் செய்யவும் அல்லது தட்டச்சு செய்யவும் — எ.கா. 8901030123456',
    placeholderManufacturer: 'எ.கா. Roche',
    placeholderStorage: 'எ.கா. 2–8 °C',
    placeholderNotes: 'பதிவு செய்ய தகுந்த வேறு எதுவும்',
    placeholderCustomUnit: 'எ.கா. பிளிஸ்டர்',
    matched: 'பொருந்தியது.',
    barcodeNoMatch:
      'இந்த பார்கோடுக்கு எந்த பொருளும் பொருந்தவில்லை. மீதியை ஒரு முறை நிரப்ப அதைக் கொண்டு செல்வோம்.',
    nmraTag: 'NMRA',
  },

  issue: {
    title: 'வழங்கல்',
    subtitle:
      'சரக்கிலிருந்து பொருட்களை வெளியிடவும். தேர்வு செய்யவும் அல்லது ஸ்கேன் செய்யவும், ஒரு தொகுதியைத் தேர்வு செய்யவும், வழங்கலுக்கு சேர்க்கவும்.',
    scanBarcode: 'பார்கோடு ஸ்கேன் செய்',
    scanHint: 'குறுக்கு வழி — பொருளைக் கண்டுபிடித்து வரியை முன்-நிரப்புகிறது',
    orSearch: 'அல்லது தேடு',
    orSearchHint: 'கீழே பிராண்ட் அல்லது பொதுவான பெயரை தட்டச்சு செய்யவும்.',
    findItem: 'பொருளைக் கண்டுபிடி',
    findItemHint: 'பிராண்ட் அல்லது பொதுவான பெயரில் குறைந்தது இரண்டு எழுத்துகளை தட்டச்சு செய்யவும்.',
    placeholderSearch: 'எ.கா. Amoxicillin',
    noItemsMatch: 'எந்த பொருளும் பொருந்தவில்லை.',
    batchLoadingHint: 'தொகுதிகள் ஏற்றப்படுகின்றன…',
    batchDefaultHint: 'பழைய காலாவதிக்கு இயல்புநிலை. தேவைப்பட்டால் கீழே வேறு ஒன்றைத் தேர்வு செய்யவும்.',
    noStockedBatches: 'கையிருப்பில் தொகுதிகள் இல்லை.',
    upToBalance: '{{balance}} வரை',
    onlyAvailable:
      'இந்த தொகுதியில் {{balance}} மட்டுமே உள்ளன — மீதிக்கு மற்றொரு வரியைச் சேர்க்கவும்.',
    addToRelease: 'வழங்கலுக்கு சேர்',
    cancelSelection: 'தேர்வை ரத்துசெய்',
    thisRelease: 'இந்த வழங்கல்',
    noLinesYet: 'இன்னும் பொருட்கள் இல்லை',
    linesAndUnits: '{{count}} {{lineLabel}} · {{units}} {{unitLabel}}',
    nothingInRelease: 'இந்த வழங்கலில் எதுவும் இல்லை',
    nothingInReleaseBody:
      'இடதுபுறம் ஒரு பொருளைத் தேர்வு செய்யவும் அல்லது ஸ்கேன் செய்யவும், ஒரு தொகுதியைத் தேர்வு செய்து, இங்கே சேர்க்கவும்.',
    addAtLeastOne: 'குறைந்தது ஒரு வரியைச் சேர்த்து, சமர்ப்பிக்கவும்.',
    submitWillRelease: 'சமர்ப்பித்தால் அனைத்து {{count}} {{lineLabel}} ஒரே நேரத்தில் வெளியிடப்படும்.',
    releaseBtn: 'வழங்கு',
    releasing: 'வெளியிடப்படுகிறது…',
    released: 'வெளியிடப்பட்டது',
    releasedBody: '{{count}} {{lineLabel}} · {{units}} {{unitLabel}} சரக்கிலிருந்து வழங்கப்பட்டன.',
    startAnotherRelease: 'மற்றொரு வழங்கலைத் தொடங்கு',
    errInsufficient:
      '{{message}}. வேறொருவர் தொகுதியை காலி செய்திருக்கலாம் — பாதிக்கப்பட்ட வரியை சரிசெய்து மீண்டும் சமர்ப்பிக்கவும்.',
    errInvalidLines: 'ஒன்று அல்லது அதற்கு மேற்பட்ட வரிகள் தவறானவை. மறுபரிசீலனை செய்து மீண்டும் முயற்சிக்கவும்.',
    errSubmitFailed: 'சமர்ப்பிக்க முடியவில்லை. சிறிது நேரத்தில் மீண்டும் முயற்சிக்கவும்.',
    unknownBarcode: 'தெரியாத பார்கோடு — இந்த பொருள் இங்கே ஒருபோதும் சேமிக்கப்படவில்லை.',
    noAvailableStockOf: '{{item}}க்கு தற்போது கையிருப்பில் இல்லை.',
    noExpiry: 'காலாவதி இல்லை',
    batchDash: 'தொகுதி —',
    nOnHand: 'கையிருப்பில் {{count}}',
  },

  adjust: {
    title: 'சரிசெய்',
    subtitle:
      'காலாவதியான, சேதமடைந்த அல்லது வேறுவிதமாக வழங்க முடியாத சரக்கை அகற்றவும். துல்லியமான தொகுதி மற்றும் காரணத்தைத் தேர்வு செய்யவும்.',
    scanBarcode: 'பார்கோடு ஸ்கேன் செய்',
    scanHint: 'குறுக்கு வழி — பொருளைக் கண்டுபிடித்து தொகுதியைத் தேர்வு செய்ய அனுமதிக்கிறது',
    orSearch: 'அல்லது தேடு',
    orSearchHint: 'கீழே பிராண்ட் அல்லது பொதுவான பெயரை தட்டச்சு செய்யவும்.',
    expiringHeading: 'காலாவதியாகும் அல்லது காலாவதியான',
    expiringSubtitle: '{{count}} {{batchLabel}} கவனம் தேவை',
    expiredOn: 'காலாவதி {{date}}',
    expDate: 'காலாவதி {{date}}',
    reasonHint: 'தேவை — விரயத்தை நுகர்விலிருந்து பிரிக்க அறிக்கைகளில் பயன்படுத்தப்படுகிறது.',
    notePlaceholder: 'விருப்ப விவரம்',
    wholeBatch: 'முழு தொகுதியையும் சரிசெய் ({{count}} {{unitLabel}})',
    onlyAvailable: 'இந்த தொகுதியில் {{balance}} மட்டுமே உள்ளன.',
    addAdjustment: 'சரிசெய்தலைச் சேர்',
    adjustmentsTitle: 'செய்ய வேண்டிய சரிசெய்தல்கள்',
    noAdjustmentsYet: 'இன்னும் சரிசெய்தல்கள் இல்லை',
    linesAndUnits: '{{count}} {{lineLabel}} · {{units}} {{unitLabel}}',
    nothingToAdjust: 'சரிசெய்ய எதுவுமில்லை',
    nothingToAdjustBody:
      'இடதுபுறம் ஒரு பொருள் அல்லது தொகுதியைத் தேர்வு செய்யவும், ஒரு காரணத்தைத் தேர்வு செய்து, இங்கே சேர்க்கவும்.',
    addAtLeastOne: 'குறைந்தது ஒரு வரியைச் சேர்த்து, மறுபரிசீலனை செய்யவும்.',
    reviewHint: 'எதையும் அகற்றுவதற்கு முன் ஒரு உறுதிப்படுத்தலைக் காண்பீர்கள்.',
    reviewBtn: 'மறுபரிசீலனை மற்றும் உறுதிப்படுத்து',
    confirmTitle: 'சரிசெய்தல்களை உறுதிப்படுத்து',
    confirmBody:
      '{{count}} {{lineLabel}} · {{units}} {{unitLabel}} சரக்கிலிருந்து அகற்றப்படும். இதை மீட்க முடியாது.',
    removeLinePlain: '{{brand}}இல் {{quantity}} {{unitLabel}} அகற்று',
    batchLabel: 'தொகுதி {{number}}',
    reasonLabel: 'காரணம்: {{reason}}',
    committing: 'செய்யப்படுகிறது…',
    commitBtn: 'சரிசெய்தல்களைச் செய்',
    adjusted: 'சரிசெய்யப்பட்டது',
    adjustedBody: '{{count}} {{lineLabel}} · {{units}} {{unitLabel}} சரக்கிலிருந்து அகற்றப்பட்டன.',
    startAnother: 'மற்றொரு சரிசெய்தலைத் தொடங்கு',
    errInsufficient:
      '{{message}}. தொகுதி இடைப்பட்ட நேரத்தில் வழங்கப்பட்டிருக்கலாம் — பாதிக்கப்பட்ட வரியை மறுபரிசீலனை செய்து மீண்டும் முயற்சிக்கவும்.',
    errInvalidLines:
      'ஒன்று அல்லது அதற்கு மேற்பட்ட வரிகள் தவறானவை. ரத்துசெய்து, பட்டியலை மறுபரிசீலனை செய்து, மீண்டும் முயற்சிக்கவும்.',
    errCommitFailed: 'செய்ய முடியவில்லை. சிறிது நேரத்தில் மீண்டும் முயற்சிக்கவும்.',
    noAvailableStockOf: '{{item}}க்கு சரிசெய்ய கையிருப்பில் இல்லை.',
    reasonExpired: 'காலாவதி',
    reasonDamaged: 'சேதம்',
    reasonDiscarded: 'நிராகரிக்கப்பட்டது',
    reasonOther: 'மற்றவை',
    pickBatchHint: 'சரிசெய்யப்படும் துல்லியமான தொகுதியைத் தேர்வு செய்யவும்.',
    confirmSingleBatchHint: 'கீழே உள்ள தொகுதியைத் தட்டி உறுதிப்படுத்தவும்.',
  },

  stock: {
    title: 'சரக்கு',
    subtitle: 'கையிருப்பில் என்ன உள்ளது, என்ன குறைகிறது, என்ன விரைவில் காலாவதியாகும்.',
    filterAll: 'அனைத்தும்',
    filterOut: 'கையிருப்பில் இல்லை',
    filterExpiring: 'விரைவில் காலாவதியாகும்',
    filterExpiringWithDays: 'விரைவில் காலாவதியாகும் ({{days}}d)',
    filterExpired: 'காலாவதியானது',
    filterByExpiry: 'காலாவதி அடிப்படையில் வடிகட்டு',
    filterByType: 'வகை அடிப்படையில் வடிகட்டு',
    allTypes: 'அனைத்து வகைகள்',
    search: 'பொருட்களைத் தேடு',
    searchPlaceholder: 'பிராண்ட் அல்லது பொதுவான பெயரால் தேடு',
    noItemsYet: 'இன்னும் பொருட்கள் இல்லை',
    onceStockComes: 'சரக்கு வந்தவுடன், பொருட்கள் இங்கே தோன்றும்.',
    noItemsMatch: 'எந்த பொருளும் பொருந்தவில்லை',
    tryDifferent: 'வேறு தேடலை முயற்சிக்கவும் அல்லது வடிகட்டிகளை அழிக்கவும்.',
    clearFilters: 'வடிகட்டிகளை அழி',
    couldNotLoadStock: 'சரக்கை ஏற்ற முடியவில்லை',
    couldNotLoadStockMsg: 'சரக்கை ஏற்ற முடியவில்லை. மீண்டும் முயற்சிக்கவும்.',
    couldNotLoadBatches: 'தொகுதிகளை ஏற்ற முடியவில்லை.',
    inStock: 'கையிருப்பில்',
    outOfStock: 'கையிருப்பில் இல்லை',
    nExpired: '{{count}} காலாவதி',
    nExpiringSoon: '{{count}} விரைவில் காலாவதி',
    nextExp: 'அடுத்த காலாவதி {{date}}',
    onHand: 'கையிருப்பு',
    zeroOnHand: 'கையிருப்பு 0',
    noStockedBatchesItem: 'கையிருப்பில் தொகுதிகள் இல்லை.',
    bringItBack: 'இந்த பொருளை மீண்டும் கொண்டு வர.',
    addStockLink: 'சரக்கு சேர்',
    noBatchesShow: 'காண்பிக்க தொகுதிகள் இல்லை.',
    discard: 'நிராகரி',
    hideDepleted: 'குறைந்த தொகுதிகளை மறை',
    showDepleted: 'குறைந்த {{count}} {{batchLabel}} காட்டு',
    showingRange: '{{total}}இல் {{start}}–{{end}} காண்பிக்கிறது',
    pageOf: 'பக்கம் {{page}} / {{totalPages}}',
    prev: 'முந்தைய',
    next: 'அடுத்து',
  },

  account: {
    title: 'உங்கள் கணக்கு',
    subtitle: 'நீங்கள் யாராக உள்நுழைந்துள்ளீர்கள், எந்தக் கடவுச்சொல்லுடன் உள்நுழைகிறீர்கள்.',
    clinics: 'நீங்கள் சேர்ந்துள்ள மருத்துவமனைகள்',
    currentClinic: 'தற்போதைய',
    changePassword: 'கடவுச்சொல்லை மாற்று',
    changePasswordBody:
      'இந்தச் சாதனத்தில் நீங்கள் உள்நுழைந்தே இருப்பீர்கள். பிற சாதனங்கள் அவற்றின் அமர்வுகள் காலாவதியாகும் வரை தொடரும்.',
    currentPassword: 'தற்போதைய கடவுச்சொல்',
    newPassword: 'புதிய கடவுச்சொல்',
    confirmPassword: 'புதிய கடவுச்சொல்லை உறுதிப்படுத்து',
    passwordHint: 'குறைந்தது {{count}} எழுத்துகள்.',
    passwordTooShort: 'குறைந்தது {{count}} எழுத்துகளைப் பயன்படுத்தவும்.',
    passwordsDoNotMatch: 'இவை இரண்டும் பொருந்தவில்லை.',
    currentPasswordWrong: 'அது உங்கள் தற்போதைய கடவுச்சொல் அல்ல.',
    newPasswordSame: 'தற்போதையதிலிருந்து வேறுபட்ட கடவுச்சொல்லைத் தேர்ந்தெடுக்கவும்.',
    passwordChanged: 'கடவுச்சொல் மாற்றப்பட்டது.',
    changing: 'மாற்றுகிறது…',
    changeFailed: 'உங்கள் கடவுச்சொல்லை மாற்ற முடியவில்லை.',
  },
  audit: {
    title: 'தணிக்கை பதிவு',
    subtitle: 'உங்கள் மருத்துவமனையில் ஒவ்வொரு அர்த்தமுள்ள மாற்றமும் — யார், எப்போது, என்ன.',
    actions: {
      stockIn: 'சரக்கு வரவு',
      stockIssue: 'சரக்கு வழங்கல்',
      stockAdjustment: 'சரக்கு சரிசெய்தல்',
      stockMovementUpdate: 'இயக்கம் திருத்தப்பட்டது',
      stockMovementDelete: 'இயக்கம் நீக்கப்பட்டது',
      itemCreate: 'பொருள் உருவாக்கப்பட்டது',
      batchCreate: 'தொகுதி உருவாக்கப்பட்டது',
      userCreate: 'பயனர் சேர்க்கப்பட்டார்',
      userUpdate: 'பயனர் புதுப்பிக்கப்பட்டார்',
      userRemove: 'பயனர் அகற்றப்பட்டார்',
      invitationCreate: 'அழைப்பு அனுப்பப்பட்டது',
      invitationRevoke: 'அழைப்பு திரும்பப் பெறப்பட்டது',
      invitationAccept: 'அழைப்பு ஏற்கப்பட்டது',
      aptTicketIssue: 'வரிசை எண் வழங்கப்பட்டது',
      aptTicketCancel: 'வரிசை எண் ரத்து செய்யப்பட்டது',
      consultationRecord: 'வருகை பதிவு செய்யப்பட்டது',
      consultationAmend: 'வருகை திருத்தப்பட்டது',
    },
    filterByActor: 'நபர்',
    filterByAction: 'செயல்',
    fromDate: 'இலிருந்து',
    toDate: 'வரை',
    allPeople: 'அனைத்து நபர்கள்',
    allActions: 'அனைத்து செயல்கள்',
    noActivityYet: 'இன்னும் செயல்பாடு இல்லை',
    noActivityBody:
      'நபர்கள் சரக்கு சேர்க்க, வழங்க, அல்லது உறுப்பினர்களை நிர்வகிக்கத் தொடங்கியதும், நீங்கள் அதைக் காண்பீர்கள்.',
    noEventsMatch: 'எந்த நிகழ்வும் பொருந்தவில்லை',
    tryWiderRange: 'பரந்த தேதி வரம்பை முயற்சிக்கவும் அல்லது வடிகட்டிகளை அழிக்கவும்.',
    couldNotLoad: 'தணிக்கை பதிவை ஏற்ற முடியவில்லை',
    couldNotLoadMsg: 'தணிக்கை பதிவை ஏற்ற முடியவில்லை. மீண்டும் முயற்சிக்கவும்.',
    clearFilters: 'வடிகட்டிகளை அழி',
    item: 'பொருள்',
    user: 'பயனர்',
    summaryBatchCreated: '{{brand}} (தொகுதி {{batchNumber}})',
    filterAll: 'அனைத்தும்',
    filterStockIn: 'சரக்கு வரவு',
    filterIssue: 'வழங்கப்பட்டது',
    filterAdjustment: 'சரிசெய்தல்',
    searchPlaceholder: 'பொருட்கள் அல்லது நபர்களைத் தேடு',
    emptyTitle: 'நகர்வுகள் பதிவாகவில்லை',
    emptyBody: 'சரக்கு செயல்பாடு நடக்கும்போது இங்கே தோன்றும்.',
    columnWhen: 'எப்போது',
    columnItem: 'பொருள்',
    columnKind: 'வகை',
    columnQuantity: 'அளவு',
    columnBatch: 'தொகுதி',
    columnReason: 'காரணம்',
    columnActor: 'மூலம்',
    loadMore: 'மேலும் ஏற்று',
    loading: 'ஏற்றப்படுகிறது…',
    by: 'மூலம்',
  },

  activity: {
    title: 'செயல்பாடு',
    subtitle: 'அனைத்து சரக்கு இயக்கங்களும், புதியவை முதலில். ஒரு தொகுதியின் சமீபத்திய இயக்கத்தை மட்டுமே திருத்த முடியும்.',
    filterKind: 'வகை',
    allKinds: 'அனைத்து இயக்கங்களும்',
    kindStockIn: 'சரக்கு சேர்ப்பு',
    kindIssue: 'வழங்கப்பட்டது',
    kindAdjustment: 'சரிசெய்தல்',
    searchPlaceholder: 'மருந்துப் பெயரால் தேடுங்கள்',
    fromDate: 'முதல்',
    toDate: 'வரை',
    clearFilters: 'வடிகட்டிகளை அழி',
    noBatch: 'தொகுதி எண் இல்லை',
    noExpiry: 'காலாவதி இல்லை',
    expires: '{{date}} அன்று காலாவதியாகும்',
    unknownActor: 'தெரியவில்லை',
    edit: 'திருத்து',
    delete: 'நீக்கு',
    lockedHint: 'பூட்டப்பட்டுள்ளது — இந்தத் தொகுதிக்கு புதிய இயக்கம் உள்ளது',
    emptyTitle: 'இதுவரை சரக்கு செயல்பாடு இல்லை',
    emptyBody: 'சரக்கு சேர்ப்பது, வழங்குவது அல்லது சரிசெய்வது இங்கே ஒவ்வொன்றாகத் தோன்றும்.',
    emptyAction: 'சரக்கு சேர்',
    noMatchTitle: 'பொருந்தும் இயக்கங்கள் இல்லை',
    noMatchBody: 'பரந்த தேதி வரம்பை முயற்சிக்கவும் அல்லது வடிகட்டிகளை அழிக்கவும்.',
    couldNotLoad: 'செயல்பாட்டை ஏற்ற முடியவில்லை',
    tryAgain: 'மீண்டும் முயற்சிக்கவும்',
    editTitle: 'இயக்கத்தைத் திருத்து',
    editStockInDescription: 'வந்ததைத் திருத்துங்கள் — அளவு, தொகுதி அல்லது பொருள்.',
    editIssueDescription: 'வெளியேறிய அளவையும் காரணத்தையும் திருத்துங்கள்.',
    quantity: 'அளவு',
    note: 'குறிப்பு',
    notePlaceholder: 'விருப்பத்தேர்வு',
    reason: 'காரணம்',
    batchSection: 'தொகுதி',
    itemSection: 'பொருள்',
    batchNumber: 'தொகுதி எண்',
    expiryDate: 'காலாவதி தேதி',
    save: 'மாற்றங்களைச் சேமி',
    saving: 'சேமிக்கிறது…',
    cancel: 'ரத்து செய்',
    noChanges: 'இதுவரை எதுவும் மாறவில்லை.',
    deleteTitle: 'இந்த இயக்கத்தை நீக்கவா?',
    deleteBody: 'இது பதிவேட்டிலிருந்து உள்ளீட்டை நீக்கி சரக்கில் அதன் விளைவை மாற்றியமைக்கும்.',
    deleteBatchWarning: 'அது உருவாக்கிய தொகுதியும் நீக்கப்படும் — வேறு எதுவும் அதிலிருந்து எடுக்கவில்லை.',
    confirmDelete: 'நீக்கு',
    deleting: 'நீக்குகிறது…',
    viewAll: 'அனைத்தையும் பார்',
  },

  analytics: {
    title: 'வழங்கல் பகுப்பாய்வு',
    subtitle: 'மருந்தகத்திலிருந்து வெளியேறியவை, எப்போது, எந்த மருந்துகளுக்கு.',

    measure: {
      units: 'அலகுகள்',
      lines: 'வழங்கல்கள்',
    },
    measureLabel: 'அளவீடு',

    mixedUnits: {
      label: 'கலப்பு அலகுகள்',
      note: 'அலகுகள் ஒவ்வொரு மருந்தின் சொந்த அலகிலேயே எண்ணப்படுகின்றன — மாத்திரைகள், மில்லிலிட்டர்கள், துண்டுகள் — எனவே பல மருந்துகளைச் சேர்த்த மொத்தம் வெவ்வேறு வகையானவற்றைக் கூட்டுகிறது. அந்த மொத்தத்தையும் அதிலிருந்து கணக்கிடப்படும் விழுக்காடுகளையும் துல்லியமானவை என்பதற்குப் பதிலாக தோராயமான குறிப்பீடுகளாகப் படியுங்கள். மருந்துகளைத் துல்லியமாக ஒப்பிட அளவீட்டை “வழங்கல்கள்” என மாற்றவும்.',
    },

    period: {
      label: 'காலம்',
      today: 'இன்று',
      week: 'இந்த வாரம்',
      month: 'இந்த மாதம்',
      last30: 'கடந்த 30 நாட்கள்',
      last90: 'கடந்த 3 மாதங்கள்',
      custom: 'தனிப்பயன்',
      from: 'தொடக்கத் தேதி',
      to: 'இறுதித் தேதி',
    },

    windowShowing: '{{from}} முதல் {{to}} வரை காட்டப்படுகிறது',

    granularity: {
      label: 'குழுவாக்கம்',
      day: 'நாள்',
      week: 'வாரம்',
      month: 'மாதம்',
    },

    filters: 'வடிகட்டிகள்',
    filtersDone: 'சரி',
    itemTypes: 'பொருள் வகைகள்',
    itemTypesAll: 'அனைத்து பொருள் வகைகளும்',
    medicine: 'மருந்து',
    medicineSearch: 'ஒரு மருந்தைத் தேடு…',
    medicineNoMatch: 'பொருந்தும் மருந்துகள் இல்லை',
    medicineSelected: '{{name}} மட்டும் காட்டப்படுகிறது',
    medicineClear: 'அனைத்து மருந்துகளையும் காட்டு',
    medicineUnknown: 'தேர்ந்தெடுத்த மருந்து',

    headline: 'சுருக்கம்',
    deltaVs_one: 'முந்தைய நாளுடன் ஒப்பிடும்போது',
    deltaVs_other: 'முந்தைய {{count}} நாட்களுடன் ஒப்பிடும்போது',
    deltaFlat: 'மாற்றம் இல்லை',

    trend: {
      title: 'போக்கு',
      aria: '{{from}} முதல் {{to}} வரை {{granularity}} வாரியாக வழங்கப்பட்ட {{measure}}, பொருள் வகை வாரியாக அடுக்கப்பட்டது',
      empty: 'இந்தக் காலத்தில் எதுவும் வழங்கப்படவில்லை.',
      partialNote:
        'மங்கலான நெடுவரிசைகள் அந்தக் காலகட்டத்தின் ஒரு பகுதியை மட்டுமே உள்ளடக்குகின்றன. எனவே அவை மற்றவற்றை விடக் குறைவாகத் தெரிகின்றன — வழங்கல் குறைந்ததால் அல்ல.',
    },

    byType: {
      title: 'பொருள் வகை வாரியாக',
      aria: 'பொருள் வகை வாரியான வழங்கல்',
      legend: 'பொருள் வகைப் பிரிவு',
      empty: 'இந்தக் காலத்தில் எதுவும் வழங்கப்படவில்லை.',
      filterTo: '{{type}} மட்டும் காட்டு',
      clear: 'அனைத்து பொருள் வகைகளையும் காட்டு',
    },

    topItems: {
      title: 'முதன்மை மருந்துகள்',
      aria: '{{measure}} வாரியாக முதன்மை மருந்துகள்',
      empty: 'இந்தக் காலத்தில் எதுவும் வழங்கப்படவில்லை.',
      select: 'அனைத்தையும் {{name}} க்கு வடிகட்டு',
      shareOfAll: 'மொத்த வழங்கலில் பங்கு',
    },

    log: {
      title: 'வழங்கல் பதிவு',
      subtitle: 'மேலுள்ள எண்களுக்குப் பின்னால் உள்ள ஒவ்வொரு வரியும்.',
      noBatch: 'தொகுதி இல்லை',
      noExpiry: 'காலாவதி இல்லை',
      expires: 'காலாவதி {{date}}',
      empty: 'இந்தக் காலத்திற்கு வழங்கல்கள் இல்லை.',
      couldNotLoad: 'வழங்கல் பதிவை ஏற்ற முடியவில்லை',
    },

    empty: {
      neverTitle: 'இதுவரை எதுவும் வழங்கப்படவில்லை',
      neverBody: 'மருந்தகத்திலிருந்து சரக்கு வெளியேறத் தொடங்கியதும், இந்தப் பக்கம் நிரம்பும்.',
      neverAction: 'ஒரு வழங்கலைப் பதிவு செய்',
      rangeTitle: 'இந்தக் காலத்தில் வழங்கல்கள் இல்லை',
      rangeBody: '{{from}} முதல் {{to}} வரை மருந்தகத்திலிருந்து எதுவும் வெளியேறவில்லை.',
      rangeAction: 'கடந்த 3 மாதங்களுக்கு விரிவாக்கு',
      medicineTitle: '{{name}} க்கு வழங்கல்கள் இல்லை',
      medicineTitleUnknown: 'தேர்ந்தெடுத்த மருந்துக்கு வழங்கல்கள் இல்லை',
      medicineBody: '{{from}} முதல் {{to}} வரை இது வழங்கப்படவில்லை.',
      medicineAction: 'மருந்து வடிகட்டியை அழி',
      filteredTitle: 'இந்த வடிகட்டிகளுக்குப் பொருந்தும் வழங்கல்கள் இல்லை',
      filteredBody: 'பரந்த காலம் அல்லது குறைவான பொருள் வகைகளை முயற்சிக்கவும்.',
      filteredAction: 'வடிகட்டிகளை அழி',
    },

    couldNotLoad: 'வழங்கல் பகுப்பாய்வை ஏற்ற முடியவில்லை',
    couldNotLoadMsg: 'இந்தக் காலத்திற்கான எண்களை ஏற்ற முடியவில்லை. மீண்டும் முயற்சிக்கவும்.',
  },

  people: {
    title: 'நபர்கள்',
    subtitle: 'உங்கள் மருத்துவமனை உறுப்பினர்களை நிர்வகிக்கவும். நிர்வாகிகளால் மட்டுமே இந்த பக்கத்தைப் பார்க்க முடியும்.',
    inviteMember: 'உறுப்பினரை அழை',
    loadingMembers: 'உறுப்பினர்கள் ஏற்றப்படுகின்றனர்…',
    couldNotLoad: 'உறுப்பினர்களை ஏற்ற முடியவில்லை. சிறிது நேரத்தில் மீண்டும் முயற்சிக்கவும்.',
    noMembersYet: 'இன்னும் உறுப்பினர்கள் இல்லை',
    addFirstTeammate: 'தொடங்க உங்கள் முதல் சக ஊழியரை அழைக்கவும்.',
    youBadge: 'நீங்கள்',
    joinedOn: 'சேர்ந்தது {{date}}',
    cantRemoveSelf: 'இந்த மருத்துவமனையிலிருந்து உங்களை நீங்களே அகற்ற முடியாது',
    membersFooter:
      'உறுப்பினர் நிலை இந்த மருத்துவமனைக்கு மட்டுமே. நீங்கள் அகற்றும் உறுப்பினரின் கணக்கும், இங்கு அவர்கள் பதிவுசெய்த அனைத்தும் அப்படியே இருக்கும்.',
    editMember: '{{name}} திருத்து',
    removeMemberTitle: '{{name}} அகற்றவா?',
    removeMemberDesc: 'இது அவர்களை இந்த மருத்துவமனையிலிருந்து அகற்றுகிறது. அவர்களின் கணக்கும், இங்கு அவர்கள் பதிவுசெய்தவையும் அப்படியே இருக்கும்.',
    removeMemberBtn: 'உறுப்பினரை அகற்று',
    removing: 'அகற்றப்படுகிறது…',
    inviteMemberDesc:
      'அவர்களுக்கு ஒரு அழைப்பை மின்னஞ்சலில் அனுப்புவோம். நீங்கள் தேர்ந்தெடுக்கும் பங்குகளுடன், அவர்களின் சொந்த Synapse கணக்கைப் பயன்படுத்தி இணைவார்கள் — இன்னும் கணக்கு இல்லையெனில் ஒன்றை உருவாக்கி.',
    invitingBtn: 'அனுப்பப்படுகிறது…',
    inviteRolesHint: 'இந்தப் பங்குகளுடன் அவர்கள் இணைவார்கள். குறைந்தது ஒன்றைத் தேர்ந்தெடுக்கவும்.',
    inviteSentEmailFailed:
      'அழைப்பு தயார், ஆனால் அதை மின்னஞ்சலில் அனுப்ப முடியவில்லை. உள்நுழைந்து தங்கள் மருத்துவமனை பட்டியலிலிருந்து ஏற்குமாறு {{email}} க்குத் தெரிவிக்கவும்.',
    emailPlaceholder: 'jane@clinic.com',
    pendingInvitations: 'நிலுவையிலுள்ள அழைப்புகள்',
    pendingInvitationsLoading: 'அழைப்புகள் ஏற்றப்படுகின்றன…',
    pendingInvitationsEmpty: 'ஏற்கப்படக் காத்திருக்கும் அழைப்புகள் இல்லை.',
    pendingInvitationsError: 'அழைப்புகளை ஏற்ற முடியவில்லை. சிறிது நேரத்தில் மீண்டும் முயற்சிக்கவும்.',
    pendingInvitationsFooter: 'ஏற்கப்படும் அல்லது திரும்பப் பெறப்படும் வரை அழைப்பு இங்கே இருக்கும்.',
    invitedOn: 'அழைக்கப்பட்டது {{date}}',
    inviteRoleDeleted: 'பங்கு நீக்கப்பட்டது',
    revokeInvite: 'அழைப்பைத் திரும்பப் பெறு',
    revokeInviteTitle: '{{email}} க்கான அழைப்பைத் திரும்பப் பெறவா?',
    revokeInviteDesc:
      'அதைக் கொண்டு அவர்களால் இணைய முடியாது. அதே முகவரியை எப்போது வேண்டுமானாலும் மீண்டும் அழைக்கலாம்.',
    revokingInvite: 'திரும்பப் பெறப்படுகிறது…',
    saving: 'சேமிக்கப்படுகிறது…',
    saveChanges: 'மாற்றங்களைச் சேமி',
    role: 'பங்கு',
    roles: 'பாத்திரங்கள்',
    rolesHint: 'உறுப்பினர்களுக்கு குறைந்தது ஒரு பாத்திரம் தேவை.',
    rolesLockedHint: 'அணுகலை நிர்வகிக்கக்கூடிய கடைசி நபர் இவர் — முதலில் வேறு ஒருவருக்கு அந்தப் பாத்திரத்தை வழங்கவும்.',
    roleLockedSuffix: '(தேவை)',
    selfRoleHint: 'உங்கள் சொந்தப் பாத்திரங்களை மாற்றும்போது கவனமாக இருங்கள் — அணுகலை இழக்கலாம்.',
    mustHaveManager: 'ஒருவரால் அணுகலை நிர்வகிக்க முடிய வேண்டும்',
    noRoles: 'அணுகல் இல்லை',
    errFieldsInvalid: 'ஒன்று அல்லது அதற்கு மேற்பட்ட புலங்கள் தவறானவை.',
    errGeneric: 'ஏதோ தவறு நடந்துள்ளது. சிறிது நேரத்தில் மீண்டும் முயற்சிக்கவும்.',
  },

  dispensary: {
    headerSetup: 'புதிய மருந்தகத்தை அமை',
    stepXOfY: 'படி {{step}} / {{total}}',
    stepDetails: 'விவரங்கள்',
    stepTeam: 'குழு',
    detailsHeading: 'அதைப் பற்றி எங்களிடம் கூறுங்கள்',
    detailsSubtitle: 'ஒரு மருந்தக பெயர் மற்றும் அது இருக்கும் இடம்.',
    teamHeading: 'உங்கள் குழுவை அழைக்கவும்',
    teamSubtitle: 'விருப்பத்தேர்வு. People இலிருந்து இதைப் பின்னர் செய்யலாம்.',
    invitesWaiting: 'உங்களுக்காக காத்திருக்கும் அழைப்புகள்',
    roleOnJoin: 'சேரும் பங்கு:',
    joining: 'சேருகிறது…',
    acceptJoin: 'ஏற்று சேர்',
    orCreateBelow: 'அல்லது கீழே உங்கள் சொந்த மருந்தகத்தை உருவாக்கவும்.',
    noInvitesFor:
      "{{email}}க்கு காத்திருக்கும் அழைப்புகள் இல்லை. ஒன்றை எதிர்பார்க்கிறீர்கள் என்றால், அந்த மின்னஞ்சலை அழைக்க நிர்வாகியிடம் கேளுங்கள் — அது தானாக இங்கே தோன்றும். அல்லது கீழே உங்கள் சொந்த மருந்தகத்தை உருவாக்கவும்.",
    nameLabel: 'மருந்தக பெயர்',
    nameHint: 'பணியிடங்களை மாற்றும்போது உங்கள் குழுவிற்குக் காட்டப்படும்.',
    namePlaceholder: 'எ.கா. Bayview North Dispensary',
    street: 'தெரு',
    city: 'நகரம்',
    region: 'மாநிலம் / பகுதி',
    postcode: 'அஞ்சல் குறியீடு',
    country: 'நாடு',
    phone: 'தொலைபேசி',
    saving: 'சேமிக்கப்படுகிறது…',
    continueBtn: 'தொடரவும்',
    firstAdminNotice:
      'நீங்கள் முதல் நிர்வாகி. வேறு யாரையும் இப்போது அழைக்கவும் அல்லது தவிர்த்து பின்னர் சேர்க்கவும்.',
    emailToInvite: 'அழைக்க மின்னஞ்சல்',
    addInviteBtn: 'சேர்',
    pendingInvites: 'நிலுவையில் உள்ள அழைப்புகள் · {{count}}',
    willReceiveEmail: 'அழைப்பு மின்னஞ்சலைப் பெறுவார்',
    skipInviteLater: 'தவிர் — பின்னர் அழைக்கவும்',
    finishing: 'முடிக்கப்படுகிறது…',
    createBtn: 'மருந்தகத்தை உருவாக்கு',
    yourDispensary: 'உங்கள் மருந்தகம்',
    inProgress: 'புதிய · செயலில்',
    readyToLaunch: 'புதிய · தொடங்கத் தயார்',
    address: 'முகவரி',
    team: 'குழு',
    oneAdminYou: '1 நிர்வாகி (நீங்கள்)',
    oneAdminInvites_one: '1 நிர்வாகி (நீங்கள்) · நிலுவையில் {{count}} அழைப்பு',
    oneAdminInvites_other: '1 நிர்வாகி (நீங்கள்) · நிலுவையில் {{count}} அழைப்புகள்',
    settingsNote: 'நீங்கள் தவிர்க்கும் எதையும் பின்னர் அமைப்புகளிலிருந்து திருத்தலாம்.',
    errCreateFailed: 'மருந்தகத்தை உருவாக்க முடியவில்லை.',
    errEmailListed: 'அந்த மின்னஞ்சல் ஏற்கனவே பட்டியலில் உள்ளது.',
    errInvitesFailed: 'சில அழைப்புகளை அனுப்ப முடியவில்லை: {{details}}',
    errAcceptFailed: 'அழைப்பை ஏற்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.',
    errUnknown: 'தெரியாத பிழை',
    errNoRoles: 'அழைக்க இந்த மருத்துவமனையில் பாத்திரங்கள் இல்லை.',
  },

  consulting: {
    title: 'இப்போது பார்க்கும் நோயாளி',
    previous: 'முந்தைய',
    nextPatient: 'அடுத்த நோயாளி',
    pastVisits: 'முந்தைய வருகைகள்',
    firstVisit: 'இந்த நோயாளிக்குப் பதிவான முதல் வருகை இதுவே.',
    nobodyTitle: 'எண் {{number}} க்கு நோயாளி யாரும் பதிவு செய்யப்படவில்லை',
    nobodyBody: 'முன் மேசை பதிவேட்டிலிருந்து நோயாளிக்கு எண் வழங்கும். எண் வழங்கப்பட்டதும் அவர்களின் விவரங்கள் இங்கே தோன்றும்.',
    alreadyRecorded: 'இன்றைய வருகை பதிவு செய்யப்பட்டது',
    noCounterAccessTitle: 'இந்தத் திரை சந்திப்பு கவுண்டரைப் பின்தொடர்கிறது',
    noCounterAccessBody: 'உங்கள் பங்கால் கவுண்டரைப் பார்க்க முடியாது. அந்த அனுமதியைச் சேர்க்க மருத்துவமனை நிர்வாகியிடம் கேளுங்கள்.',
  },
  visits: {
    title: 'வருகையைப் பதிவு செய்',
    subtitle: 'மருத்துவரின் குறிப்புகளை உள்ளிடவும்: நோயறிதல், இங்கு வழங்கிய மருந்துகள் மற்றும் வெளியில் வாங்க வேண்டிய மருந்துகள்.',
    waitingTitle: 'பதிவு செய்ய காத்திருப்பவை',
    waitingEmpty: 'எண் பெற்ற யாரும் பதிவு செய்ய காத்திருக்கவில்லை.',
    recordFor: 'எண் {{number}}, {{name}} க்கான வருகையைப் பதிவு செய்',
    otherPatientTitle: 'வேறொரு நோயாளி',
    recordedTitle: 'இன்று பதிவு செய்யப்பட்டவை',
    recordedEmpty: 'இன்று இன்னும் வருகைகள் பதிவு செய்யப்படவில்லை.',
    couldNotLoadRecorded: 'இன்றைய வருகைகளை ஏற்ற முடியவில்லை.',
    couldNotLoadVisit: 'இந்த வருகையை ஏற்ற முடியவில்லை.',
    editFor: '{{name}} இன் வருகையைத் திருத்து',
    backToVisits: 'வருகைகளுக்குத் திரும்பு',
    visitDate: 'வருகை தேதி',
    diagnosis: 'நோயறிதல்',
    diagnosisHint: 'மருத்துவர் எழுதியபடியே உள்ளிடவும்.',
    diagnosisPlaceholder: 'நோயறிதல் மற்றும் குறிப்புகள்…',
    diagnosisTooLong: '{{max}} எழுத்துகளுக்குள் வைக்கவும்.',
    issuedTitle: 'மருத்துவமனையிலிருந்து வழங்கிய மருந்துகள்',
    issuedSubtitle: 'சேமிக்கும்போது இவை மருத்துவமனை இருப்பிலிருந்து குறையும்.',
    issuedToAdd: 'வழங்க வேண்டியவை',
    addToVisit: 'வருகையில் சேர்',
    outsideTitle: 'வெளியில் வாங்க வேண்டிய மருந்துகள்',
    outsideSubtitle: 'நோயாளி வேறிடத்தில் வாங்குவதற்காக எழுதப்பட்டது. இருப்பு பாதிக்கப்படாது.',
    outsideEmpty: 'எதுவும் சேர்க்கப்படவில்லை.',
    outsideAdd: 'மருந்து சேர்',
    outsideName: 'மருந்து',
    outsideDose: 'அளவு',
    outsideFrequency: 'எத்தனை முறை',
    outsideDuration: 'எவ்வளவு காலம்',
    outsideNameN: 'வெளி மருந்து {{n}} பெயர்',
    outsideDoseN: 'வெளி மருந்து {{n}} அளவு',
    outsideFrequencyN: 'வெளி மருந்து {{n}} எத்தனை முறை',
    outsideDurationN: 'வெளி மருந்து {{n}} எவ்வளவு காலம்',
    outsideRemoveN: 'வெளி மருந்து {{n}} ஐ நீக்கு',
    finishPicking: 'சேமிக்கும் முன் தேர்ந்தெடுத்த மருந்தைச் சேர்க்கவும் அல்லது ரத்து செய்யவும்.',
    needsContent: 'நோயறிதல் அல்லது குறைந்தது ஒரு மருந்தை உள்ளிடவும்.',
    saveWillRecord: 'சேமித்தால் வருகை பதிவாகி இருப்பு புதுப்பிக்கப்படும்.',
    saveWillAmend: 'சேமித்தால் வருகை புதுப்பிக்கப்பட்டு இருப்பு சரிசெய்யப்படும்.',
    saving: 'சேமிக்கப்படுகிறது…',
    saveVisit: 'வருகையைச் சேமி',
    saveChanges: 'மாற்றங்களைச் சேமி',
    changesSaved: 'மாற்றங்கள் சேமிக்கப்பட்டன.',
    recorded: 'வருகை பதிவு செய்யப்பட்டது',
    recordedBody: '{{name}} இன் வருகை சேமிக்கப்பட்டு இருப்பு புதுப்பிக்கப்பட்டது.',
    nextPatient: 'அடுத்த நோயாளி',
    editThisVisit: 'இந்த வருகையைத் திருத்து',
    lineLocked: 'அதன் பின் இருப்பு மாறியுள்ளது — இந்த வரியை இனி மாற்ற முடியாது',
    lineWillReturn: 'இருப்புக்குத் திரும்பும்',
    lineKeep: 'வைத்திரு',
    lineRemoveFor: '{{name}} ஐ இந்த வருகையிலிருந்து நீக்கு',
    lineKeepFor: '{{name}} ஐ இந்த வருகையில் வைத்திரு',
  },
  aptCounter: {
    title: 'சந்திப்பு கவுண்டர்',
    subtitle:
      'வரிசை எண் மற்றும் மருத்துவர் கிடைப்பை நிர்வகிக்கவும். காத்திருப்பு அறைக்காக QR ஐ அச்சிடவும்.',
    joinClinicFirst: 'முதலில் ஒரு மருத்துவமனையில் சேரவும் அல்லது உருவாக்கவும்.',
    couldNotLoad: 'கவுண்டரை ஏற்ற முடியவில்லை.',
    decrement: 'குறை',
    increment: 'அதிகரி',
    setCounter: 'கவுண்டர் எண்ணை அமை',
    setBtn: 'அமை',
    doctorIn: 'மருத்துவர் உள்ளார்',
    doctorOut: 'மருத்துவர் வெளியே உள்ளார்',
    editDoctorName: 'மருத்துவர் பெயரைத் திருத்து',
    markDoctorIn: 'மருத்துவர் உள்ளே எனக் குறி',
    updateDoctorName: 'மருத்துவர் பெயரைப் புதுப்பி',
    doctorOnDuty: 'பணியிலுள்ள மருத்துவர்',
    doctorDialogDesc: 'மருத்துவர் உள்ளே இருக்கும் போது நோயாளி காட்சி இந்த பெயரைக் காட்டும்.',
    doctorNamePlaceholder: 'டாக்டர். ...',
    doctorName: 'மருத்துவர் பெயர்',
    qrTitle: 'நோயாளி காட்சி QR',
    qrAriaLabel: 'நோயாளி காட்சிக்கான QR குறியீடு',
    nowServing: 'இப்போது சேவை செய்வது',
    waiting: 'காத்திருக்கும்',
    next: 'அடுத்து',
    callNext: 'அடுத்தவரை அழை',
    skip: 'தவிர்',
    reset: 'மீட்டமை',
    publicView: 'பொது காட்சியைத் திற',
    queueEmpty: 'வரிசை காலியாக உள்ளது.',
    addToQueue: 'வரிசையில் சேர்',
    confirmReset: 'கவுண்டரை பூஜ்ஜியத்திற்கு மீட்டமைக்கவா?',
    confirmResetBody: 'இது தற்போதைய வரிசையை அழித்து மீண்டும் தொடங்கும்.',
    counter: 'கவுண்டர்',
    todaysQueue: 'இன்றைய வரிசை',
    waitingCount: '{{count}} பேர் காத்திருக்கின்றனர்',
    couldNotLoadQueue: 'இன்றைய வரிசையை ஏற்ற முடியவில்லை.',
    giveNumber: 'எண் கொடு',
    givingNumber: 'எண் கொடுக்கப்படுகிறது…',
    queueNumber: 'எண்',
    numberToday: 'இன்று எண் {{number}}',
    numberLabel: 'எண் {{number}}',
    statusCancelled: 'ரத்து செய்யப்பட்டது',
    statusRecorded: 'பதிவு செய்யப்பட்டது',
    keepNumber: 'வைத்திரு',
    confirmCancelNumber: 'எண் {{number}} ஐ ரத்து செய்',
    cancelNumberFor: '{{name}} க்கான எண் {{number}} ஐ ரத்து செய்',
    connecting: 'இணைக்கப்படுகிறது…',
    connected: 'நேரலை',
    offline: 'ஆஃப்லைன்',
  },

  publicCounter: {
    nowServing: 'இப்போது சேவை செய்வது',
    doctorOut: 'மருத்துவர் வெளியே உள்ளார்',
    displayUnavailable: 'காட்சி கிடைக்கவில்லை',
    linkInvalid: 'இந்த கவுண்டர் இணைப்பு இனி செல்லுபடியாகாது.',
    reconnecting: 'மீண்டும் இணைக்கப்படுகிறது…',
  },

  qr: {
    generateFailed: 'QR குறியீட்டை உருவாக்க முடியவில்லை',
    downloadPng: 'PNG பதிவிறக்கு',
    copyLink: 'இணைப்பை நகலெடு',
    copied: 'இணைப்பு நகலெடுக்கப்பட்டது',
    copyFailed: 'நகலெடுக்க முடியவில்லை — மேலே உள்ள இணைப்பை கையால் நகலெடுங்கள்.',
    downloadFailed: 'படத்தை உருவாக்க முடியவில்லை. மீண்டும் முயலுங்கள், அல்லது மேலே உள்ள குறியீட்டைத் திரைப்பிடிப்பு எடுங்கள்.',
  },

  publicRegister: {
    heading: 'நோயாளியாகப் பதிவு செய்யுங்கள்',
    at: '{{clinic}} இல்',
    intro: 'உங்கள் விவரங்களை நிரப்பி, வரவேற்பில் இந்தத் திரையைக் காட்டுங்கள்.',
    submit: 'பதிவைச் சமர்ப்பி',
    submitting: 'சமர்ப்பிக்கப்படுகிறது…',
    nameRequired: 'உங்கள் முழுப் பெயரை உள்ளிடவும்.',
    submitFailed: 'உங்கள் பதிவைச் சமர்ப்பிக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.',
    rateLimited: 'அதிக முயற்சிகள். சிறிது நேரம் காத்திருந்து மீண்டும் முயற்சிக்கவும்.',
    loading: 'ஏற்றப்படுகிறது…',
    linkInvalid: 'இந்தப் பதிவு இணைப்பு செல்லுபடியாகாது.',
    linkInvalidBody: 'மருத்துவமனையிடம் புதிய இணைப்பைக் கேளுங்கள், அல்லது கவுண்டரில் பதிவு செய்யுங்கள்.',
    doneTitle: 'நன்றி',
    doneBody: 'உங்கள் விவரங்கள் மருத்துவமனைக்கு அனுப்பப்பட்டுள்ளன. பதிவை முடிக்க வரவேற்பைச் சந்திக்கவும்.',
    privacyNote: 'உங்கள் விவரங்கள் இந்த மருத்துவமனைக்கு மட்டுமே அனுப்பப்படும். உங்கள் பதிவு உருவாக்கப்படும் முன் ஊழியர்கள் அவற்றைச் சரிபார்ப்பார்கள்.',
  },

  patientPortal: {
    loading: 'ஏற்றப்படுகிறது…',
    mrnLabel: 'நோயாளி எண்',
    labsTitle: 'ஆய்வக முடிவுகள்',
    noLabs: 'உங்களுக்கான ஆய்வகப் பரிசோதனைகள் இதுவரை பதிவு செய்யப்படவில்லை.',
    orderedOn: 'கோரிய நாள்',
    collectedOn: 'மாதிரி எடுத்த நாள்',
    notCollectedYet: 'மாதிரி இன்னும் எடுக்கப்படவில்லை.',
    awaitingResult: 'முடிவு இன்னும் இல்லை',
    viewReport: 'அறிக்கையைப் பார்',
    reportOpening: 'திறக்கப்படுகிறது…',
    reportFor: '{{test}} அறிக்கையைப் பார்',
    reportFailed: 'அந்த அறிக்கையைத் திறக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.',
    clinicalNote: 'இந்த முடிவுகள் உங்கள் பதிவுக்காக மட்டுமே. இங்குப் படிப்பதன் அடிப்படையில் எதையும் செய்வதற்கு முன் உங்கள் மருத்துவரிடம் கலந்தாலோசியுங்கள்.',
    notFoundTitle: 'இந்த இணைப்பு செல்லுபடியாகாது.',
    notFoundBody: 'மருத்துவமனையிடம் புதிய இணைப்பைக் கேளுங்கள்.',
    linkButton: 'நோயாளி இணைப்பு',
    linkModalTitle: 'நோயாளியுடன் முடிவுகளைப் பகிர்',
    linkModalDesc: 'இந்த இணைப்பைத் திறந்து நோயாளி தமது ஆய்வக முடிவுகளைப் பார்க்கலாம்.',
    linkCardTitle: 'உங்கள் முடிவுகள்',
    linkAriaLabel: 'இந்த நோயாளியின் முடிவுகள் பக்கத்திற்கான QR குறியீடு',
    linkWarning: 'இந்த இணைப்பு உள்ள எவரும் இந்த நோயாளியின் ஆய்வக முடிவுகளைப் பார்க்க முடியும். இதை நோயாளியிடம் மட்டுமே கொடுங்கள்.',
  },

  selfRegistrations: {
    qrButton: 'பதிவு QR',
    qrModalTitle: 'நோயாளி சுய-பதிவு',
    qrModalDesc: 'இந்தக் குறியீட்டை அச்சிடுங்கள் அல்லது காட்டுங்கள். அதை ஸ்கேன் செய்யும் நோயாளிகள் தங்கள் விவரங்களை உள்ளிடலாம், அவை சரிபார்ப்புக்காக இங்கே தோன்றும்.',
    qrCardTitle: 'இங்கே பதிவு செய்யுங்கள்',
    qrAriaLabel: 'நோயாளி சுய-பதிவுக்கான QR குறியீடு',
    qrLanguage: 'படிவ மொழி',
    qrLanguageHint: 'இந்தக் குறியீட்டை ஸ்கேன் செய்யும் நோயாளிகளுக்குப் படிவம் இந்த மொழியில் திறக்கும். அவர்கள் அதை மாற்றிக்கொள்ளலாம்.',
    pending: 'நிலுவையில்',
    pendingTitle: 'நிலுவையிலுள்ள பதிவுகள்',
    pendingEmpty: 'சரிபார்ப்புக்குக் காத்திருக்கும் பதிவுகள் இல்லை.',
    pendingSubtitle: 'நோயாளிகளால் சமர்ப்பிக்கப்பட்டவை. விவரங்களைச் சரிபார்த்து, பதிவு செய்யுங்கள் அல்லது நிராகரியுங்கள்.',
    submittedAgo: '{{when}} சமர்ப்பிக்கப்பட்டது',
    review: 'சரிபார்',
    reviewTitle: 'பதிவைச் சரிபார்',
    reviewSubtitle: 'நோயாளி உள்ளிட்டதைச் சரிபார்த்து, தவறுகளைத் திருத்தி, பதிவு செய்யுங்கள்.',
    approve: 'அங்கீகரித்துப் பதிவு செய்',
    approving: 'பதிவு செய்யப்படுகிறது…',
    reject: 'நிராகரி',
    rejecting: 'நிராகரிக்கப்படுகிறது…',
    rejectConfirm: 'இந்தப் பதிவை நிராகரிக்கவா?',
    rejectConfirmBody: 'சமர்ப்பிப்பு பதிவுக்காக வைக்கப்படும், ஆனால் நோயாளி உருவாக்கப்பட மாட்டார்.',
    nationalIdUnreadable: 'சமர்ப்பிக்கப்பட்ட அடையாள எண்ணைப் படிக்க முடியவில்லை. மீண்டும் உள்ளிடவும் அல்லது காலியாக்கவும்.',
    approveFailed: 'இந்த நோயாளியைப் பதிவு செய்ய முடியவில்லை.',
    rejectFailed: 'இந்தப் பதிவை நிராகரிக்க முடியவில்லை.',
    approvedButPhotoFailed: 'நோயாளி பதிவு செய்யப்பட்டார், ஆனால் புகைப்படத்தைச் சேமிக்க முடியவில்லை.',
    couldNotLoad: 'பதிவுகளை ஏற்ற முடியவில்லை.',
    backToQueue: 'பதிவுகளுக்குத் திரும்பு',
    openPatient: 'நோயாளி பதிவைத் திற',
    showingSomeOf: 'காத்திருக்கும் {{total}} இல் பழைய {{shown}} காட்டப்படுகிறது. மீதியைப் பார்க்க இவற்றைச் சரிபாருங்கள்.',
  },

  errors: {
    VALIDATION_ERROR: 'சில தகவல்கள் இல்லை அல்லது தவறானவை. சரிபார்த்து மீண்டும் முயற்சிக்கவும்.',
    UNAUTHORIZED: 'உங்கள் அமர்வு முடிந்துவிட்டது. மீண்டும் உள்நுழையவும்.',
    FORBIDDEN: 'அதைச் செய்ய உங்களுக்கு அனுமதி இல்லை.',
    NOT_FOUND: 'நீங்கள் தேடியதை எங்களால் கண்டுபிடிக்க முடியவில்லை.',
    CONFLICT: 'அந்த செயல் தற்போதைய நிலையுடன் முரண்படுகிறது. புதுப்பித்து மீண்டும் முயற்சிக்கவும்.',
    INSUFFICIENT_STOCK: 'இந்த செயலை முடிக்க போதுமான சரக்கு இல்லை.',
    RATE_LIMITED: 'அதிக முயற்சிகள். சிறிது நேரம் காத்திருந்து மீண்டும் முயற்சிக்கவும்.',
    INTERNAL_ERROR: 'எங்கள் பக்கத்தில் ஏதோ தவறு நடந்துள்ளது. மீண்டும் முயற்சிக்கவும்.',
    INTERNAL_CONSISTENCY: 'எங்கள் பக்கத்தில் ஏதோ தவறு நடந்துள்ளது. மீண்டும் முயற்சிக்கவும்.',
    PARSE_ERROR: 'சேவையகம் எதிர்பாராத பதிலை அனுப்பியது.',
    NETWORK_ERROR: 'சேவையகத்தை அடைய முடியவில்லை. உங்கள் இணைப்பைச் சரிபார்த்து மீண்டும் முயற்சிக்கவும்.',
    NOT_A_MEMBER: 'இந்த மருத்துவமனைக்கு உங்களுக்கு அணுகல் இல்லை.',
    CLINIC_DISABLED: 'இந்த மருத்துவமனை முடக்கப்பட்டுள்ளது. உங்கள் நிர்வாகியைத் தொடர்பு கொள்ளவும்.',
    fallback: 'ஏதோ தவறு நடந்துள்ளது. மீண்டும் முயற்சிக்கவும்.',
  },

  platformAdmin: {
    title: 'தள நிர்வாகம்',
    backToClinics: 'மருத்துவமனைகளுக்குத் திரும்பு',
    loading: 'ஏற்றுகிறது…',
    tabs: {
      clinics: 'மருத்துவமனைகள்',
      passwords: 'கடவுச்சொற்கள்',
      superAdmins: 'முதன்மை நிர்வாகிகள்',
    },
    users: {
      minChars: 'தேட குறைந்தது {{count}} எழுத்துகளைத் தட்டச்சு செய்யவும்.',
      noMatches: 'பொருந்துபவர் யாரும் இல்லை.',
      searchFailed: 'அதைத் தேட முடியவில்லை.',
    },
    clinicDetail: {
      back: 'அனைத்து மருத்துவமனைகள்',
      created: '{{date}} அன்று உருவாக்கப்பட்டது',
      joined: '{{date}} அன்று சேர்ந்தார்',
      membersTitle: 'உறுப்பினர்கள்',
      noMembers: 'இந்த மருத்துவமனையில் இதுவரை யாரும் சேரவில்லை.',
      membersLoadFailed: 'இந்த மருத்துவமனையின் உறுப்பினர்களை ஏற்ற முடியவில்லை.',
      loadFailed: 'இந்த மருத்துவமனையை ஏற்ற முடியவில்லை.',
    },
    clinics: {
      title: 'மருத்துவமனைகள்',
      subtitle: 'தளத்தில் உள்ள அனைத்து மருத்துவமனைகளும். முழுமையாகப் பூட்ட ஒன்றை முடக்கவும்.',
      searchPlaceholder: 'பெயர் அல்லது URL மூலம் தேடவும்',
      memberCount_one: '{{count}} உறுப்பினர்',
      memberCount_other: '{{count}} உறுப்பினர்கள்',
      disabledBadge: 'முடக்கப்பட்டது',
      disable: 'முடக்கு',
      enable: 'இயக்கு',
      empty: 'பொருந்தும் மருத்துவமனைகள் இல்லை.',
      loadFailed: 'மருத்துவமனைகளை ஏற்ற முடியவில்லை.',
      toggleFailed: 'அந்த மருத்துவமனையை மாற்ற முடியவில்லை.',
      confirmTitle: '{{name}} ஐ முடக்கவா?',
      confirmBody_one:
        'அதன் {{count}} உறுப்பினர் உடனடியாக அணுகலை இழப்பார், QR பக்கங்களும் நோயாளர் இணைப்புகளும் செயலிழக்கும். எப்போது வேண்டுமானாலும் மீண்டும் இயக்கலாம்.',
      confirmBody_other:
        'அதன் {{count}} உறுப்பினர்கள் உடனடியாக அணுகலை இழப்பார்கள், QR பக்கங்களும் நோயாளர் இணைப்புகளும் செயலிழக்கும். எப்போது வேண்டுமானாலும் மீண்டும் இயக்கலாம்.',
    },
    passwords: {
      title: 'கடவுச்சொல்லை மீட்டமை',
      subtitle:
        'மின்னஞ்சல் மீட்டமைப்பு இணைப்பைப் பயன்படுத்த முடியாதவருக்கு நேரடியாகக் கடவுச்சொல் அமைக்கவும். மின்னஞ்சல் எதுவும் அனுப்பப்படாது.',
      searchLabel: 'பயனரைத் தேடு',
      searchPlaceholder: 'மின்னஞ்சல் அல்லது பெயர் மூலம் தேடவும்',
      setPassword: 'கடவுச்சொல்லை அமை',
      dialogTitle: '{{name}} க்கு புதிய கடவுச்சொல் அமைக்கவும்',
      dialogDesc: 'இது {{email}} இன் கடவுச்சொல்லை உடனடியாக மாற்றும்.',
      newPassword: 'புதிய கடவுச்சொல்',
      confirmPassword: 'கடவுச்சொல்லை உறுதிப்படுத்து',
      tooShort: 'குறைந்தது {{count}} எழுத்துகளைப் பயன்படுத்தவும்.',
      mismatch: 'இரு கடவுச்சொற்களும் பொருந்தவில்லை.',
      relayHint:
        'மின்னஞ்சல் எதுவும் அனுப்பப்படாது. புதிய கடவுச்சொல்லை நீங்களே அவரிடம் சொல்லி, உள்நுழைந்ததும் அதை மாற்றச் சொல்லுங்கள்.',
      done: '{{email}} இன் கடவுச்சொல் மாற்றப்பட்டது.',
      failed: 'அந்தக் கடவுச்சொல்லை மாற்ற முடியவில்லை.',
    },
    superAdmins: {
      title: 'முதன்மை நிர்வாகிகள்',
      subtitle: 'இந்தக் கட்டுப்பாட்டுப் பலகையை யார் அணுகலாம்.',
      add: 'முதன்மை நிர்வாகியைச் சேர்',
      addTitle: 'முதன்மை நிர்வாகியைச் சேர்',
      addDesc:
        'ஏற்கெனவே உள்ள கணக்கைத் தேடி உயர்த்தவும். இன்னும் கணக்கு இல்லையென்றால் முதலில் பதிவு செய்யச் சொல்லுங்கள் — இது கணக்கை உருவாக்குவதில்லை, எனவே யாருக்கும் கடவுச்சொல் கொடுக்க வேண்டியதில்லை.',
      searchLabel: 'பயனரைத் தேடு',
      searchPlaceholder: 'மின்னஞ்சல் அல்லது பெயர் மூலம் தேடவும்',
      promote: 'உயர்த்து',
      promoteFailed: 'அந்தப் பயனரை உயர்த்த முடியவில்லை.',
      alreadyOne: 'ஏற்கெனவே முதன்மை நிர்வாகி',
      demote: 'நீக்கு',
      demoteTitle: '{{name}} ஐ நீக்கவா?',
      demoteDesc: '{{email}} அடுத்த கோரிக்கையில் இந்தக் கட்டுப்பாட்டுப் பலகைக்கான அணுகலை இழப்பார்.',
      demoteFailed: 'அந்தப் பயனரை நீக்க முடியவில்லை.',
      lastOneHint: 'குறைந்தது ஒரு முதன்மை நிர்வாகி எஞ்சியிருக்க வேண்டும்.',
      loadFailed: 'முதன்மை நிர்வாகிகளை ஏற்ற முடியவில்லை.',
    },
  },

  roles: {
    title: 'பாத்திரங்கள்',
    subtitle: 'உங்கள் மருத்துவமனையில் ஒவ்வொரு பாத்திரமும் என்ன செய்ய முடியும் என வரையறுக்கவும்.',
    newRole: 'புதிய பாத்திரம்',
    loading: 'பாத்திரங்கள் ஏற்றப்படுகின்றன…',
    loadFailed: 'பாத்திரங்களை ஏற்ற முடியவில்லை. சிறிது நேரத்தில் மீண்டும் முயலவும்.',
    empty: 'இன்னும் பாத்திரங்கள் இல்லை',
    managesAccess: 'அணுகலை நிர்வகிக்கிறது',
    cannotGrantHint: 'உங்களிடம் இல்லாத அனுமதியை உங்களால் வழங்க முடியாது.',
    noDescription: 'விளக்கம் இல்லை',
    permissionCount: '{{count}} அனுமதிகள்',
    memberCount: '{{count}} உறுப்பினர்கள்',
    lastManagerRoleHint: 'அணுகலை நிர்வகிக்கக்கூடிய ஒரே பாத்திரம் இதுவே — நீக்கும் முன் மற்றொன்றை உருவாக்கவும்.',
    footer: 'பாத்திரங்கள் இந்த மருத்துவமனைக்கு மட்டுமே. ஒவ்வொருவருக்கும் குறைந்தது ஒன்று தேவை.',
    editRole: '{{name}} திருத்து',
    dialogDesc: 'இந்தப் பாத்திரம் வைத்திருப்பவர்கள் செய்யக்கூடிய அனைத்தையும் தேர்வுசெய்யவும்.',
    name: 'பாத்திரப் பெயர்',
    namePlaceholder: 'வழங்குநர்',
    description: 'விளக்கம்',
    descriptionPlaceholder: 'இந்தப் பாத்திரம் எதற்காக',
    permissions: 'அனுமதிகள்',
    saveFailed: 'பாத்திரத்தைச் சேமிக்க முடியவில்லை.',
    deleteRole: '{{name}} நீக்கவா?',
    deleteConfirm: 'இந்தப் பாத்திரத்தில் உறுப்பினர்கள் இல்லை. நீக்குவதை மீட்டமைக்க முடியாது.',
    deleteWarning: '{{count}} உறுப்பினர்கள் இந்தப் பாத்திரத்தை வைத்துள்ளனர், அது வழங்கும் அணுகலை இழப்பார்கள்.',
    deleteFailed: 'பாத்திரத்தை நீக்க முடியவில்லை.',
  },

  permissions: {
    groups: {
      patients: 'நோயாளர்கள்',
      clinical: 'மருத்துவப் பதிவு',
      inventory: 'இருப்பு',
      lab: 'ஆய்வகம்',
      frontDesk: 'வரவேற்பு',
      insights: 'நுண்ணறிவு மற்றும் மேற்பார்வை',
      clinic: 'மருத்துவமனை அமைப்புகள்',
      people: 'நபர்கள் மற்றும் அணுகல்',
    },
    keys: {
      patients_read_label: 'நோயாளர்களைப் பார்க்க',
      patients_read_description: 'நோயாளர் பதிவேட்டைப் பார்த்து ஒரு நோயாளரின் விவரங்களைத் திறக்கவும்.',
      patients_create_label: 'நோயாளர்களைப் பதிவு செய்ய',
      patients_create_description: 'பதிவேட்டில் புதிய நோயாளர்களைச் சேர்க்கவும்.',
      patients_update_label: 'நோயாளர் விவரங்களைத் திருத்த',
      patients_update_description: 'ஒரு நோயாளரின் தனிப்பட்ட விவரங்களைத் திருத்தவும்.',
      patients_delete_label: 'நோயாளர்களை நீக்க',
      patients_delete_description: 'பதிவேட்டிலிருந்து ஒரு நோயாளரை நீக்கவும்.',
      patients_photo_manage_label: 'நோயாளர் புகைப்படங்களை நிர்வகிக்க',
      patients_photo_manage_description: 'ஒரு நோயாளரின் புகைப்படத்தை எடுக்க, மாற்ற அல்லது நீக்க.',
      clinical_consultations_read_label: 'ஆலோசனைகளைப் பார்க்க',
      clinical_consultations_read_description: 'ஆலோசனைக் குறிப்புகளையும் முந்தைய வருகைகளையும் படிக்கவும்.',
      clinical_consultations_write_label: 'ஆலோசனைகளை எழுத',
      clinical_consultations_write_description: 'ஆலோசனைக் குறிப்புகளைத் தொடங்கி திருத்தவும்.',
      clinical_consultations_finalize_label: 'ஆலோசனைகளை இறுதி செய்ய',
      clinical_consultations_finalize_description: 'மேலும் திருத்தங்களுக்கு எதிராக ஒரு ஆலோசனையை மூடவும்.',
      clinical_history_read_label: 'மருத்துவ வரலாற்றைப் பார்க்க',
      clinical_history_read_description: 'ஒரு நோயாளரின் தொடர்ச்சியான மருத்துவ வரலாற்றைப் படிக்கவும்.',
      clinical_history_write_label: 'மருத்துவ வரலாற்றைத் திருத்த',
      clinical_history_write_description: 'ஒரு நோயாளரின் மருத்துவ வரலாற்றைப் புதுப்பிக்கவும்.',
      visits_record_label: 'வருகைகளைப் பதிவு செய்ய',
      visits_record_description: 'மருத்துவரின் குறிப்புகளிலிருந்து வருகையைப் பதிவு செய்து, அதன் மருந்துகளை வழங்கி, பின்னர் திருத்தவும்.',
      inventory_items_read_label: 'இருப்பு பட்டியலைப் பார்க்க',
      inventory_items_read_description: 'பொருட்கள், தொகுதிகள் மற்றும் காலாவதியாகும் பொருட்களைப் பார்க்கவும்.',
      inventory_items_create_label: 'புதிய பொருட்களைச் சேர்க்க',
      inventory_items_create_description: 'இருப்பு பட்டியலில் புதிய பொருட்களை உருவாக்கவும்.',
      inventory_stock_in_label: 'இருப்பைப் பெற',
      inventory_stock_in_description: 'மருத்துவமனைக்கு வரும் இருப்பைப் பதிவு செய்யவும்.',
      inventory_stock_issue_label: 'இருப்பை வழங்க',
      inventory_stock_issue_description: 'நோயாளர்களுக்கு இருப்பை வழங்கவும்.',
      inventory_stock_adjust_label: 'இருப்பைச் சரிசெய்ய',
      inventory_stock_adjust_description: 'இழப்பு, சேதம் அல்லது காலாவதிக்கான அளவுகளைச் சரிசெய்யவும்.',
      inventory_movements_read_label: 'இருப்பு நடவடிக்கைகளைப் பார்க்க',
      inventory_movements_read_description: 'இருப்பு நகர்வுகளின் முழு பேரேட்டைப் பார்க்கவும்.',
      inventory_movements_correct_label: 'இருப்பு நடவடிக்கைகளைத் திருத்த',
      inventory_movements_correct_description: 'பதிவு செய்யப்பட்ட இருப்பு நகர்வைத் திருத்த அல்லது நீக்கவும்.',
      dashboard_read_label: 'கட்டுப்பாட்டுப் பலகையைப் பார்க்க',
      dashboard_read_description: 'முகப்புப் பக்க இருப்புச் சுருக்கத்தைப் பார்க்கவும்.',
      dashboard_activity_read_label: 'சமீபத்திய நடவடிக்கைகளைப் பார்க்க',
      dashboard_activity_read_description: 'சமீபத்திய இருப்பு நகர்வுகளை யார் பதிவு செய்தார்கள் எனப் பார்க்கவும்.',
      apt_counter_read_label: 'சந்திப்பு எண்ணிக்கையைப் பார்க்க',
      apt_counter_read_description: 'தற்போதைய வரிசை எண்ணைப் பார்க்கவும்.',
      apt_counter_manage_label: 'சந்திப்பு எண்ணிக்கையை இயக்க',
      apt_counter_manage_description: 'முன்னேற்ற, மீட்டமைக்க மற்றும் பணியில் உள்ள மருத்துவரை அமைக்க.',
      self_registrations_read_label: 'சுய பதிவுகளைப் பார்க்க',
      self_registrations_read_description: 'QR மூலம் தாங்களே பதிவு செய்த நோயாளர்களைப் பார்க்கவும்.',
      self_registrations_review_label: 'சுய பதிவுகளை அங்கீகரிக்க',
      self_registrations_review_description: 'சுய பதிவு சமர்ப்பிப்புகளை அங்கீகரிக்க அல்லது நிராகரிக்க.',
      suggestions_read_label: 'சேமித்த பரிந்துரைகளைப் பயன்படுத்த',
      suggestions_read_description: 'மருத்துவமனையின் சேமித்த உரைப் பட்டியல்களைப் படிக்கவும்.',
      lab_read_label: 'ஆய்வக ஆணைகளைப் பார்க்க',
      lab_read_description: 'ஆய்வகப் பணிப்பட்டியல், ஒரு ஆணையின் விவரங்கள், அறிக்கைப் பட்டியல் ஆகியவற்றைப் பார்க்கவும்.',
      lab_orders_create_label: 'ஆய்வக ஆணைகளை உருவாக்க',
      lab_orders_create_description: 'ஒரு நோயாளிக்கு புதிய ஆணையை உருவாக்கவும்.',
      lab_orders_update_label: 'ஆய்வக ஆணைகளைத் திருத்த',
      lab_orders_update_description: 'ஆணையை மாற்றவும் அல்லது ரத்து செய்யவும், அல்லது அதிலுள்ள ஒரு பரிசோதனையை ரத்து செய்யவும்.',
      lab_specimens_collect_label: 'மாதிரிகளைப் பதிவு செய்ய',
      lab_specimens_collect_description: 'மாதிரி எடுக்கப்பட்டதைப் பதிவு செய்யவும், அல்லது மீண்டும் எடுக்க நிராகரிக்கவும்.',
      lab_results_upload_label: 'ஆய்வக அறிக்கைகளைப் பதிவேற்ற',
      lab_results_upload_description: 'ஒரு பரிசோதனையின் PDF அறிக்கையை இணைக்கவும் அல்லது மாற்றவும்.',
      lab_results_read_label: 'ஆய்வக அறிக்கைகளைத் திறக்க',
      lab_results_read_description: 'PDF அறிக்கைகளைத் திறந்து பதிவிறக்கவும்.',
      lab_results_delete_label: 'ஆய்வக அறிக்கைகளை நீக்க',
      lab_results_delete_description: 'தவறுதலாகப் பதிவேற்றப்பட்ட அறிக்கையை நீக்கவும்.',
      lab_catalogue_manage_label: 'ஆய்வகப் பரிசோதனைப் பட்டியலை நிர்வகிக்க',
      lab_catalogue_manage_description: 'இந்த மருத்துவமனை வழங்கும் பரிசோதனைகளைச் சேர்க்க, மறுபெயரிட அல்லது மறைக்க.',
      analytics_read_label: 'வழங்கல் பகுப்பாய்வைப் பார்க்க',
      analytics_read_description: 'என்ன வழங்கப்பட்டது, யாரால், எப்போது எனப் பார்க்கவும்.',
      audit_read_label: 'தணிக்கைப் பதிவைப் பார்க்க',
      audit_read_description: 'யார் எதை மாற்றினார்கள் என்பதன் முழுப் பதிவைப் பார்க்கவும்.',
      clinic_update_label: 'மருத்துவமனை விவரங்களைத் திருத்து',
      clinic_update_description:
        'மருத்துவமனையின் பெயரையும் அதன் வலை முகவரியையும் மாற்றவும். முகவரியை மாற்றுவது ஏற்கெனவே உள்ள இணைப்புகளையும் அச்சிடப்பட்ட QR குறியீடுகளையும் செயலிழக்கச் செய்யும்.',
      members_read_label: 'உறுப்பினர்களைப் பார்க்க',
      members_read_description: 'இந்த மருத்துவமனையில் உள்ளவர்களின் பட்டியலைப் பார்க்கவும்.',
      members_create_label: 'உறுப்பினர்களைச் சேர்க்க',
      members_create_description: 'இந்த மருத்துவமனையில் நபர்களைச் சேர்க்கவும்.',
      members_update_label: 'உறுப்பினர் சுயவிவரங்களைத் திருத்த',
      members_update_description: 'ஒரு உறுப்பினரின் பெயரை மாற்ற அல்லது கடவுச்சொல்லை மீட்டமைக்க.',
      members_remove_label: 'உறுப்பினர்களை நீக்க',
      members_remove_description: 'இந்த மருத்துவமனையிலிருந்து ஒருவரை நீக்கவும்.',
      invitations_read_label: 'அழைப்புகளைப் பார்க்க',
      invitations_read_description: 'நிலுவையில் உள்ள அழைப்புகளைப் பார்க்கவும்.',
      invitations_create_label: 'அழைப்புகளை அனுப்ப',
      invitations_create_description: 'மின்னஞ்சல் மூலம் ஒருவரை இணைய அழைக்கவும்.',
      invitations_revoke_label: 'அழைப்புகளை ரத்து செய்ய',
      invitations_revoke_description: 'ஓர் அழைப்பு பெறப்படுவதற்கு முன் ரத்து செய்யவும்.',
      roles_read_label: 'பாத்திரங்களைப் பார்க்க',
      roles_read_description: 'மருத்துவமனையின் பாத்திரங்களையும் ஒவ்வொன்றும் அனுமதிப்பதையும் பார்க்கவும்.',
      roles_manage_label: 'அணுகலை நிர்வகிக்க',
      roles_manage_description: 'பாத்திரங்களை உருவாக்கி திருத்தி, யார் வைத்திருப்பது எனத் தீர்மானிக்கவும். அனைவரின் அணுகலையும் கட்டுப்படுத்துகிறது.',
    },
  },

};
